export const elTranslations: Record<string, string> = {
  order_now: 'Παράγγειλε τώρα',
  order_: 'Παράγγειλε',
  open_: 'Άνοιγμα',
  start_ordering: 'Ξεκίνα να παραγγέλνεις',
  download_android_app: 'Κατέβασε το BOX Android Application',
  connect_register: 'Σύνδεση/Εγγραφή',
  appetite_for: 'Έχεις όρεξη για',
  delivery_where_you_always_win: 'Το delivery που πάντα κερδίζεις!',
  box_dishes_more_shops:
    'Τώρα με το BOX έχεις φαγητό από ακόμα περισσότερα καταστήματα στην πόρτα σου, γεμάτο πόντους που ξέρεις καλά ότι μόνο στο BOX μπορείς να εξαργυρώσεις, σε GB και εκπτώσεις.',
  see_here_how: 'Δες εδώ πώς',
  discover_more_than_shops: 'Ανακάλυψε πάνω από 13.000 ',
  shops_in_x_cities: 'καταστήματα, σε 100 πόλεις',
  make_purchase_online: 'Κάνε τα ψώνια σου online σε',
  more_than_x_items: 'πάνω από 15.000 προϊόντα',
  place_your_address: 'Βάλε τη διεύθυνσή σου',
  have_shops: 'Έχεις κατάστημα;',
  join_team: 'Έλα στην ομάδα μας',
  download_app_for_mobile: 'Κατέβασε το BOX app στο κινητό σου',
  discover_cuisines: 'Ανακάλυψε τις κουζίνες μας',
  find_my_location: 'Βρές την τοποθεσία μου',
  no_results_found: 'Ουπς, δεν βρέθηκαν καταστήματα!',
  try_typing_address_in_form: 'Δοκίμασε να γράψεις την διεύθυνσή σου στην μορφή "Λεωφόρος Μεσογείων 2, 11527, Αθήνα".',
  enter_comment_in_next_steps: 'Μπορείς να προσθέσεις σχόλια στο επόμενο βήμα',
  order_exclamation: 'Παράγγειλε!',
  gemh_: 'ΓΕΜΗ',
  faqs_: 'Συχνές ερωτήσεις',
  our_team_is_here_to_help:
    'Η ομάδα μας είναι στη διάθεσή σου, κάθε μέρα, 07:00 - 03:00, για να σε βοηθήσει με οποιαδήποτε ερώτηση έχεις.',
  data_privacy_policy: 'Πολιτική Προστασίας Δεδομένων',
  organism_title: 'Επωνυμία: ΟΡΓΑΝΙΣΜΟΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε.',
  useful_: 'Χρήσιμα',
  order_completion: 'Ολοκλήρωση παραγγελίας',
  terms_of_use: 'Όροι Χρήσης',
  follow_on_social: 'Ακολούθησε το BOX στα social media!',
  take_box_with_you: 'Πάρε το BOX μαζί σου!',
  address_khfisias: 'Διεύθυνση: Λεωφ. Κηφισίας αρ. 99, Μαρούσι',
  cookies_settings: 'Ρυθμίσεις cookies',
  communication_: 'Επικοινωνία',
  in_num_cities: 'Σε 100 πόλεις',
  afm_: 'ΑΦΜ',
  shops_for: 'Καταστήµατα για',
  new_shops_in_area: 'Νέα καταστήµατα στην περιοχή',
  results_sorting: 'Ταξινόμηση αποτελεσμάτων',
  order_online: 'Παράγγειλε Online',
  shops_in_area: 'Καταστήματα Delivery στην περιοχή',
  most_popular_shops: 'Τα πιο δημοφιλή καταστήματα',
  find_suitable_cuisines_for_area: 'Βρες Κουζίνες που σου ταιριάζουν στην περιοχή',
  everything_to_know_about_area: 'Όσα πρέπει να ξέρεις για την περιοχή',
  looking_for_more_shops_in_the_area: 'Ψάχνεις άλλες γεύσεις στην περιοχή ',
  you_can_find_shops_by_pressing:
    'Μην ανησυχείς όμως, μπορείς να ανακαλύψεις χιλιάδες επιλογές καταστημάτων και δεκάδες επιλογές στην\n                περιοχή σου πατώντας',
  is_it_your_type: 'Είναι του γούστου σου;',
  here_: 'εδώ',
  delivery_new_shops_in_box: 'Delivery - Νέα καταστήµατα στο BOX',
  delivery_areas: 'Delivery - Περιοχές',
  online_delivery: 'Online Delivery',
  online_delivery_areas: 'Περιοχές Online Delivery',
  seo_location_cuisine_3:
    '_CUISINE_NAME delivery _LOCATION_NAME, _CUISINE_NAME online delivery _LOCATION_NAME, _CUISINE_NAME delivery προσφορές ${locationName}',
  seo_location_cuisine_2:
    '_CUISINE_NAME Delivery _LOCATION_NAME. Βρες προσφορές & καταστήµατα για delivery _CUISINE_NAME στην περιοχή _LOCATION_NAME. Παράγγειλε online και κέρδισε GB και πόντους.',
  seo_location_cuisine_1: '_CUISINE_NAME Delivery _LOCATION_NAME | Παράγγειλε Online',
  seo_text_3:
    '_NAME Delivery. Βρες προσφορές delivery & καταστήµατα στην περιοχή _NAME. Παράγγειλε online και κέρδισε GB και πόντους.',
  seo_text_2:
    '_NAME delivery, _NAME delivery κοντά µου, _NAME online delivery, _NAME online παραγγελία, _NAME delivery προσφορές',
  seo_text_1:
    '_NAME Delivery. Βρες προσφορές & καταστήµατα delivery για _NAME. Παράγγειλε online και κέρδισε GB και πόντους',
  seo_text_4: '_NAME Delivery | Παράγγειλε Online',
  the_only_rewarding_delivery:
    'ΤΟ ΜΟΝΟ FOOD DELIVERY APP ΠΟΥ <br />\n        ΣΕ ΕΠΙΒΡΑΒΕΥΕΙ ΚΑΘΕ ΦΟΡΑ ΠΟΥ <br />\n        ΠΑΡΑΓΓΕΛΝΕΙΣ!',
  download_box: 'ΚΑΤΕΒΑΣΕ ΤΟ BOX!',
  box_in_100_cities: 'BOXαρε σε 100 πόλεις!',
  cookies_part1:
    'Τα cookies και άλλοι παρόμοιοι μηχανισμοί ιχνηλάτησης (εφεξής cookies) είναι σημαντικοί για την εύρυθμη\n              λειτουργία του www.box.gr και για την βελτίωση της online εμπειρίας σας. Χρησιμοποιούμε cookies για:',
  cookies_part2:
    'την πραγματοποίηση της σύνδεσης στην ιστοσελίδα ή για την παροχή μιας υπηρεσίας διαδικτύου, την οποία έχετε ζητήσει (<strong>cookies αναγκαία και λειτουργικότητας</strong>). Χωρίς αυτά τα cookies δεν είναι τεχνικά εφικτή η σύνδεσή σας στην ιστοσελίδα μας ή δεν είναι εφικτό να σας παρέχουμε μια υπηρεσία που εσείς μας ζητήσατε (π.χ. cookies που αφορούν την καταχώρηση των αγορών σας στο ηλεκτρονικό μας κατάστημα). <strong>Για τον λόγο αυτό αυτά τα cookies είναι πάντα ενεργοποιημένα.</strong>',
  cookies_part3:
    'την συλλογή <strong>συγκεντρωτικών πληροφοριών</strong> που μας επιτρέπουν να αντιληφθούμε πώς οι χρήστες χρησιμοποιούν τον ιστότοπό μας και βοηθούν στο να βελτιώσουμε την λειτουργία, την δομή και το περιεχόμενό του (<strong>cookies επιδόσεων</strong>).',
  cookies_part4:
    'την προσαρμογή διαφημιστικού περιεχομένου (<strong>cookies στόχευσης διαφήμισης</strong>), ώστε να αντικατοπτρίζει τις ιδιαίτερες ανάγκες και τα ενδιαφέροντά σας και την μέτρηση ή/και βελτίωση αποτελεσματικότητας των διαφημιστικών μας καμπανιών.',
  cookies_part5:
    'Πατήστε <strong>«Αποδοχή cookies»</strong> για την <strong>ενεργοποίηση όλων των cookies</strong> ή <strong>«Απόρριψη cookies»</strong> για την <strong>ενεργοποίηση μόνο της κατηγορίας «Cookies αναγκαία και λειτουργικότητας»</strong> ή επιλέξτε <strong>«Περισσότερες πληροφορίες»</strong> για να επιλέξετε ποια cookies επιθυμείτε να χρησιμοποιηθούν.',
  exclusively_for_subscribers: 'Αποκλειστικά για τους συνδρομητές _SEGMENT_USERS!',
  our_wu_users: 'What’s Up Student χρήστες μας',
  doy_: 'ΔΟΥ',
  cannot_find_address: 'Αδυναμία εύρεσης διεύθυνσης',
  missing_elements_from_address:
    'Δυστυχώς η επιλεγμένη διεύθυνση δεν έχει ολοκληρωμένα στοιχεία. Παρακαλούμε, εισήγαγε μία άλλη διεύθυνση, για να προχωρήσεις.',
  won_the_first: 'Μόλις κέρδισες τους πρώτους',
  last_week_u_won: 'Την προηγούμενη εβδομάδα κέρδισες',
  last_month_u_won: 'Τον προηγούμενο μήνα κέρδισες',
  delivery_estimation_almost_at: '_DELIVERY_ESTIMATION_MINUTES’, περίπου στις _DELIVERY_ESTIMATION_TIME',
  delivery_tomorrow_almost_start_end_slot: 'Αύριο, περίπου στις _DELIVERY_START_SLOT-_DELIVERY_END_SLOT',
  delivery_today_almost_start_end_slot: 'Σήμερα, περίπου στις _DELIVERY_START_SLOT-_DELIVERY_END_SLOT',
  online_delivery_you_always_win: 'BOX Online Delivery | Το delivery που πάντα κερδίζεις',
  box_the_only_rewarding_delivery_app:
    'ΒΟΧ. Το μόνο food delivery app που σε επιβραβεύει. Κατέβασέ το, παράγγειλε και κέρδισε MB και εκπτώσεις!',
  download_box_and_earn: 'Κατέβασε το BOΧ, Παράγγειλε Online, Κέρδισε Εκπτώσεις & ΜΒ!',
  order_now_exclamation: 'Παράγγειλε τώρα!',
  afm_field_is_invalid: 'Το πεδίο ΑΦΜ είναι δεν είναι σωστό',
  doy_field_is_required: 'Το πεδίο ΔΟΥ είναι <strong>υποχρεωτικό</strong>',
  deliveryman_tip_selection_range:
    'Το φιλοδώρημα θα το λάβει εξ ολοκλήρου ο διανομέας! Μπορείς να επιλέξεις από 0,2_CURRENCY εώς 20_CURRENCY.',
  child_smile: 'Χαμόγελο του Παιδιού',
  one_minute: '1 λεπτού',
  deliveryman_tip: 'Tip διανομέα',
  box_hour_ended: 'To BOX Hour έληξε',
  the_coupon_is_valid_for_over_minimum_price: 'To κουπόνι ισχύει για παραγγελίες άνω των minimum_price',
  cannot_redeem: 'Αδυναμία εξαργύρωσης',
  cancel_: 'Άκυρο',
  change_: 'Αλλαγή',
  change_unavailable_product_with: 'Αλλαγή μη διαθέσιμου προϊόντος με',
  changing_the_time_of_a_scheduled_order: 'Αλλαγή ώρας προγραμματισμένης παραγγελίας',
  other_: 'Άλλο',
  search_shop_or_product: 'Αναζήτησε κατάστημα ή προϊόν',
  search_shop_dish: 'Αναζήτησε κατάστημα, πιάτο ή υλικό',
  search_: 'Αναζήτηση',
  card_search: 'Αναζήτηση κάρτας',
  discover_: 'Ανακάλυψε',
  waiting_restaurant_order_acceptance: 'Αναμένουμε την αποδοχή της παραγγελίας σου από το κατάστημα.',
  products_refresh: 'Ανανέωση προϊόντων',
  disable_: 'Ανενεργή',
  reopens_date_at: 'Ανοίγει ξανά _DATE στις _FUTURE_OPEN_TIME',
  reopens_tomorrow_at: 'Ανοίγει ξανά αύριο στις _FUTURE_OPEN_TIME',
  reopens_at: 'Ανοίγει ξανά στις _FUTURE_OPEN_TIME',
  copy_code_to_clipboard: 'Αντιγραγή του κωδικού κουπονιού στο πρόχειρο',
  copy_to_clipboard: 'Αντιγραφή στο πρόχειρο',
  delivery_fee: 'Αξία διανομής',
  reviews_: 'Αξιολογήσεις',
  win_from_the_discount: 'Από την έκπτωση κερδίζεις',
  delivery_receipt: 'Απόδειξη',
  i_accept_the_gift: 'Αποδέχομαι το δώρο',
  accept_cookies: 'Αποδοχή Cookies',
  save_: 'Αποθήκευση',
  save_options: 'Αποθήκευση Επιλογών',
  save_as: 'Αποθήκευση ως',
  exclusive_offer: 'Αποκλειστική προσφορά',
  reject_cookies: 'Απόρριψη Cookies',
  send_: 'Αποστολή',
  send_again: 'Αποστολή ξανά',
  send_again_in: 'Αποστολή ξανά σε',
  payment_failure: 'Αποτυχία πληρωμής',
  later_: 'Αργότερα',
  number_: 'Αριθμός',
  address_number: 'Αριθμός Διεύθυνσης',
  card_number: 'Αριθμός κάρτας',
  home_page: 'Αρχική',
  tomorrow_: 'Αύριο',
  the_page_is_currently_unavailable: 'Αυτή τη στιγμή η σελίδα δεν είναι διαθέσιμη.',
  remove_card: 'Αφαίρεση _CARD_NAME',
  remove_: 'Αφαίρεση',
  remove_from_cart: 'Αφαίρεση από το καλάθι',
  got_: 'Πήρες',
  insert_address_text: 'Βάλε την διεύθυνση σου και ξεκίνα να boxάρεις!',
  help_us_get_better: 'Βοήθησέ μας να γίνουμε καλύτεροι!',
  we_found: 'Βρήκαμε',
  thats_why_your_voucher_cannot_be_activated: 'Για αυτό το κουπόνι σου δεν μπορεί να ενεργοποιηθεί',
  to_participate_you_need_to_connect: 'Για να πάρεις μέρος στον διαγωνισμό πρέπει να συνδεθείς στην εφαρμογή',
  for_more_info: 'Για περισσότερες πληροφορίες',
  for_you: 'Για σένα',
  for_mobile_usage: 'για το κινητό σου',
  write_your_comment_here: 'Γράψε το σχόλιό σου εδώ',
  no_saved_cards_found: 'Δε βρέθηκαν αποθηκευμένες κάρτες.',
  no_results_found_for: 'Δε βρέθηκαν αποτελέσματα για _SEARCH_TERM',
  coupons_not_found: 'Δε βρέθηκαν κουπόνια.',
  see_shops_dishes_ingredients: 'Δες καταστήματα, πιάτα και υλικά',
  discover_shops: 'Ανακάλυψε καταστήματα',
  unavailable_coupons_not_found: 'Δε βρέθηκαν μη διαθέσιμα κουπόνια.',
  no_products_found_in_this_category: 'Δε βρέθηκαν προϊόντα σε αυτή την κατηγορία.',
  contact_data: 'Δεδομένα επικοινωνίας',
  we_dont_recognize_this_coupon: 'Δεν αναγνωρίζουμε αυτό το κουπόνι.',
  do_not_accept_the_gift: 'Δεν αποδέχομαι το δώρο',
  no_reviews_found_for_this_product: 'Δεν βρέθηκαν αξιολογήσεις για αυτό το προϊόν.',
  you_did_not_receive_the: 'Δεν έλαβες το',
  no_saved_cards: 'Δεν έχεις αποθηκεύμενες κάρτες',
  not_enough_bonus_points_for_redemption: 'Δεν έχεις αρκετούς Bonus πόντους για εξαργύρωση!',
  cannot_redeem_cart_is_less_than:
    'Η εξαργύρωση δεν μπορεί να πραγματοποιηθεί γιατί η αξία του καλαθιού σου είναι μικρότερη από _EURO_DISCOUNT. Μπορείς να προσθέσεις περισσότερα προϊόντα στο καλάθι για να την αποκτήσεις.',
  win_1_eur_for_4_order_eur:
    'Εξαργύρωσέ τους κατά την αποστολή της παραγγελίας σου και κέρδισε 1_CURRENCY; σε 4_CURRENCY; παραγγελίας!',
  data_protection_terms_updated: "Οι 'Οροι Προστασίας Δεδομένων ενημερώθηκαν",
  u_can_see_updates_in_data_protection_terms_page:
    'Μπορείς πάντα να δεις τις αλλαγές στην κατηγορία "Οροι Προστασίας Δεδομένων" στο προφίλ σου.',
  use_terms_updated: "Οι 'Οροι Χρήσης ενημερώθηκαν",
  u_can_see_updates_in_use_terms_page: 'Μπορείς πάντα να δεις τις αλλαγές στην κατηγορία "Οροι Χρήσης" στο προφίλ σου.',
  personalization_terms_updated: "Οι 'Οροι Εξατομίκευσης ενημερώθηκαν",
  u_can_see_updates_in_personalization_page:
    'Μπορείς πάντα να δεις τις αλλαγές στην κατηγορία "Οροι Εξατομίκευσης" στο προφίλ σου.',
  see_updates_by_pressing_learn_more: 'Μπορείς να δεις τις αλλαγές πατώντας "Μάθε περισσότερα".',
  learn_more: 'Μάθε περισσότερα',
  after_every_order_u_can_get: 'Με την ολοκλήρωση της κάθε παραγγελίας σου μπορείς να πάρεις:',
  after_order_u_can_get: 'Επιπλέον, με την ολοκλήρωση της κάθε παραγγελίας σου μπορείς να πάρεις:',
  after_first_order_u_get: 'Με την ολοκλήρωση της πρώτης σου παραγγελίας θα λάβεις:',
  you_didnt_cover_the_min_order: 'Δεν κάλυψες την ελάχιστη παραγγελία',
  no_reviews_for_this_shop: 'Δεν υπάρχουν αξιολογήσεις για αυτό το κατάστημα.',
  see_details: 'Δες αvαλυτικά',
  see_other_shops: 'Δες άλλα καταστήματα',
  see_in_depth: 'Δες Αναλυτικά',
  see_all_shops: 'Δες όλα τα καταστήματα',
  see_more_products: 'Δές περισσότερα προϊόντα',
  see_more_offers: 'Δες περισσότερες προσφορές',
  see_them_all: 'Δες τα όλα',
  see_the_shop: 'Δες το κατάστημα',
  create_new_card: 'Δημιουργία νέας κάρτας',
  read_and_accept_the: 'Διάβασα και αποδέχομαι τους',
  delete_: 'Διαγραφή',
  delete_address: 'Διαγραφή διεύθυνσης',
  delete_profile: 'Διαγραφή προφίλ',
  contests_: 'Διαγωνισμοί',
  delivery_: 'Delivery',
  delivery_to_address: 'Διανομή σε _ADDRESS_TYPE',
  diet_: 'Διατροφή',
  cookies_management: 'Διαχείριση cookies και παρόμοιων τεχνολογιών',
  addresses_: 'Διευθύνσεις',
  address_: 'Διεύθυνση',
  activity_: 'Δραστηριότητα',
  gift_: 'ΔΩΡΟ!',
  here_you_earn: 'Εδώ κερδίζεις',
  i_am_sure: 'Είμαι σίγουρος',
  coupon_insertion: 'Εισαγωγή κουπονιού',
  insert_new_coupon: 'Εισαγωγή νέου κουπονιού',
  are_u_sure_u_discard_the_present: 'Είσαι σίγουρος ότι δεν θες να αποδεχτείς το δώρο σου;',
  discount_: 'ΕΚΠΤΩΣΗ',
  minimum_order_title: 'Ελάχιστη παραγγελία',
  minimum_order: 'Ελάχιστη παραγγελία:',
  expired_: 'Έληξε',
  enable_: 'Ενεργή',
  active_until: 'Ενεργό έως',
  activate_: 'Ενεργοποίησε το',
  redeeming_: 'Εξαργυρώνεις',
  redeem_: 'Εξαργύρωσε',
  redeem_points_while_waiting_or_at_the_end_of_the_order_and_get_gb:
    'Εξαργύρωσε πόντους κατά την αναμονή ή στο τέλος της παραγγελίας και πάρε GB για το κινητό σου',
  redeem_points_when_sending_your_order_and_earn_discounts:
    'Εξαργύρωσε πόντους κατά την αποστολή της παραγγελίας σου και κέρδισε εκπτώσεις:',
  you_will_find_the_relevant_option_on_the_my_order_page:
    'Θα βρεις τη σχετική επιλογή στη σελίδα “Η παραγγελία μου” μόλις ολοκληρώσεις το καλάθι σου!',
  redeem_your_coupon: 'Εξαργύρωσε το κουπόνι σου',
  coupon_redemption: 'Εξαργύρωση κουπονιού',
  points_redemption: 'Εξαργύρωση πόντων',
  pending_points_redemption: 'Εξαργύρωση πόντων σε εκκρεμότητα',
  order_progress: 'Εξέλιξη παραγγελίας',
  smart_replacement: 'Έξυπνη αντικατάσταση',
  edit_: 'Επεξεργασία',
  confirm_: 'ΟΚ',
  data_confirmation: 'Επιβεβαίωση στοιχείων',
  last_name: 'Επίθετο',
  contact_us: 'Επικοινώνησε μαζί μας',
  choose_a_category: 'Επίλεξε κατηγορία',
  choose_where_you_wantto_take_your_meal: 'Επίλεξε που θέλεις να παραλάβεις το γέυμα σου',
  choices_: 'Επιλογές',
  payment_method_choice: 'Επιλογή τρόπου πληρωμής',
  time_selection: 'Επιλογή ώρας',
  back_: 'Επιστροφή',
  back_to_home_page: 'Επιστροφή στην αρχική',
  next_step: 'Επόμενο βήμα',
  work_: 'Εργασία',
  restaurants_: 'Εστιατόρια',
  thanks_for_your_tip: 'Ευχαριστούμε για το tip σου!',
  thank_u_very_much: 'Ευχαριστούμε πολύ!',
  apply_: 'Εφαρμογή',
  device_mode_applied: 'Εφαρμόζεται ο τρόπος εμφάνισης της συσκευής',
  you_have: 'Έχεις',
  you_have_already_earned_6x_points: 'Έχεις ήδη κερδίσει 6x πόντους',
  do_you_have_any_allergy: 'Έχεις κάποια αλλεργία;',
  the_cookies_rejection_was_saved: 'Η Απόρριψη των Cookies αποθηκεύτηκε.',
  acceptance_of_cookies_was_saved: 'Η Αποδοχή των Cookies αποθηκεύτηκε.',
  your_critic_makes_us_better: 'Η γνώμη σου μας βοηθάει να γινόμαστε καλύτεροι!',
  address_not_found: 'Η διεύθυνση δε βρέθηκε',
  the_address_is_too_far_away: 'Η διεύθυνση είναι πολύ μακριά',
  my_address: 'Η διεύθυνση μου',
  your_address: 'Η διεύθυνσή σου',
  contest_participation_at: 'Η εγγραφή σου έγινε στον διαγωνισμό στις _REGISTRATION_DATE',
  irreversible_process: 'Η ενέργεια είναι μη αναστρέψιμη',
  or_select_ingredients: 'ή επιλέξτε υλικά',
  your_review: 'Η κριτική σου',
  my_order: 'Η παραγγελία μου',
  your_order_has_been_rejected: 'Η παραγγελία σου δεν έγινε αποδεκτή.',
  your_order_has_been_accepted: 'Η παραγγελία σου έγινε αποδεκτή!',
  your_order_is_on_its_way: "Η παραγγελία σου είναι καθ' οδόν!",
  your_order_is_very_closed: 'Η παραγγελία σου είναι πολύ κοντά!',
  your_order_is_being_prepared: 'Η παραγγελία σου ετοιμάζεται!',
  gift_rejected: 'Η παραλαβή του δώρου έχει ακυρωθεί.',
  happy_hour_offer_is_out_of_hours: 'Η προσφορά happy hour είναι εκτός ωραρίου',
  the_delivery_time_you_have_selected_is_unavailable:
    'Η ώρα παράδοσης που έχεις επιλέξει δεν είναι διαθέσιμη. Μπορείς να προγραμματίσεις παραγγελία',
  days_: 'ημέρες',
  day_: 'ημέρα',
  birth_date: 'Ημερομηνία γέννησης',
  expiration_date: 'Ημερομηνία λήξης',
  we_will_replace_the_product_with_one_of_equivalent_quality_and_value:
    'Θα αντικαταστήσουμε το προϊόν με ένα αντίστοιχης ποιότητας κι αξίας',
  we_will_remove_the_product_from_your_order_and_the_final_cost:
    'Θα αφαιρέσουμε το προϊόν από την παραγγελία σου και το τελικό κόστος',
  it_will_be_ready_for_pickup: 'Θα είναι έτοιμη για παραλαβή:',
  at_your_door: 'Θα είναι στην πόρτα σου',
  do_u_want_to_rate: 'Θα ήθελες να αξιολογήσεις την εμπειρία σου στο BOX app;',
  tell_us_what_you_liked_more: 'Πες μας τι σου άρεσε περισσότερο;',
  tell_us_what_you_did_not_like: 'Πες μας τι δεν πήγε καλά; Tι μπορούμε να βελτιώσουμε;',
  your_opinion_is_precious: 'Η γνώμη σου είναι πολύτιμη.',
  choose_number_where_gb_will_go_to:
    'Επίλεξε σε ποιόν αριθμό σου θέλεις να πιστώνονται τα GB που θα κερδίσεις με την εξαργύρωση των πόντων σου!',
  i_will_take_from_the_shop: 'Θα παραλάβω από το κατάστημα',
  i_will_take_with_delivery: 'Θα παραλάβω με delivery',
  we_will_call_you_to_choose_the_replacement_product_together:
    'Θα σε καλέσουμε για να επιλέξουμε μαζί το προϊόν αντικατάστασης',
  do_you_want_us_to_notice_anything: 'Θέλεις να προσέξουμε κάτι;',
  i_want_to_participate: 'Θέλω να πάρω μέρος',
  order_history: 'Ιστορικό',
  valid_: 'Ισχύει:',
  terms_apply: 'Ισχύουν όροι',
  maybe_later: 'Ίσως αργότερα',
  and_earn: 'και κέρδισε',
  welcome_to_box: 'Καλωσήρθες στο ΒΟΧ',
  your_phone_is_needed_to_contact_with_you:
    'Το κινητό σου θα χρειαστεί για να επικοινωνήσουμε μαζί σου μέσω SMS σε περίπτωση που είσαι ένας από τους νικητές και δεν θα χρησιμοποιηθεί για κανέναν άλλο σκοπό.',
  to_participate_accept_terms_and_give_phone:
    'Για να πάρεις μέρος στον διαγωνισμό θα χρειαστεί να αποδεχτείς τους όρους του διαγωνισμού και να συμπληρώσεις το κινητό σου τηλέφωνο στο παρακάτω πεδίο.',
  no_change: 'Καμία αλλαγή',
  register_to_box_to_invite_friends: 'Κάνε εγγραφή/σύνδεση στο ΒΟΧ για να προσκαλέσεις φίλους και να κερδίσεις πόντους',
  supermarket_cards: 'Κάρτες Supermarket',
  shops_: 'Καταστήματα',
  download_huawei_app: 'Κατέβασε το BOX Huawei Applciation',
  download_ios_app: 'Κατέβασε το BOX iOS Applciation',
  navigate_to_store: 'Κατευθυνόμαστε προς το κατάστημα!',
  something_went_wrong: 'Κάτι πήγε στραβά!',
  get_a_discount_up_to: 'Κέρδισε έκπτωση έως και',
  win_with_every_order: 'Κέρδισε με κάθε παραγγελία',
  win_multiple_points: 'Κέρδισε πολλαπλούς πόντους',
  mobile_: 'Κινητό',
  ok_: 'Ok',
  mobile_phone: 'Κινητό τηλέφωνο',
  close_: 'Κλείσιμο',
  closed_: 'Κλειστό',
  call_: 'Κλήση',
  share_location: 'Κοινοποιήση τοποθεσίας',
  name_at_bell: 'Κουδούνι',
  verification_code: 'Κωδικός επιβεβαίωσης',
  less_: 'Λιγότερα',
  account_: 'Λογαριασμός',
  due_to_increased_traffic_unfortunately_the_shop_was_closed: 'Λόγω αυξημένου φόρτου, δυστυχώς το κατάστημα έκλεισε.',
  sorry_page_not_found: 'Λυπούμαστε, η σελίδα δε βρέθηκε',
  with_your_order_you_won: 'Με την παραγγελία σου κέρδισες',
  maximum_product_purchase_limit: 'Μέγιστο όριο αγοράς προϊόντος',
  maximum_delivery_limit: 'Μέγιστο όριο παράδοσης',
  cash_: 'Μετρητά',
  cash_or_pos_upon_receipt: 'Μετρητά ή POS κατά την παραλαβή',
  try_again: 'Προσπάθησε ξανά',
  try_again_in_a_bit: 'Προσπάθησε ξανά σε λίγο.',
  help_us_highlight_the_best_shops: 'Μέχρι να φτάσει το γεύμα σου, βοήθησέ μας να αναδείξουμε τα καλύτερα καταστήματα!',
  unavailable_: 'Μη διαθέσιμα',
  unavailable_products: 'Μη διαθέσιμα προϊόντα',
  no_delivery_times_available: 'Μη διαθέσιμες ώρες παράδοσης',
  unavailable_delivery_time: 'Μη διαθέσιμη ώρα παράδοσης',
  invalid_email: 'Μη έγκυρο Email',
  dont_forget: 'Μην ξεχνάς!',
  maybe_the_next_day: 'Μήπως την επόμενη μέρα;',
  an_order_with_a_card: 'Μια παραγγελία με κάρτα',
  you_just_won: 'Μόλις κέρδισες',
  you_can_find_the_friends_invitation_in_your_profile_at_any_time:
    'Μπορείς να βρεις οποιοδήποτε στιγμή την Πρόσκληση φίλων στο Προφίλ σου',
  you_can_close_page: 'Μπορείς να κλείσεις την σελίδα',
  you_can_order_from_other_shops: 'Μπορείς να παραγγείλεις από άλλα καταστήματα.',
  yes_: 'Ναι',
  yes_want: 'Ναι, θέλω!',
  unlock_it_by_placing_orders_over: 'Ξεκλείδωσέ το κάνοντας παραγγελίες άνω των',
  mobile_number_is_invalid: 'Το κινητό πρέπει να αποτελείται από 10 ψηφία',
  contest_expiration_at: 'Λήξη διαγωνισμού: _REMAINING_TIME',
  contest_expired: 'Ο διαγωνισμός έληξε',
  deliveryman_is_navigating_to_store: 'Ο διανομέας είναι στο δρόμο προς το κατάστημα!',
  deliveryman_is_waiting_to_receive_your_order: 'Ο διανομέας περιμένει να παραλάβει την παραγγελία σου!',
  the_code_is: 'Ο κωδικός είναι:',
  verification_code_error_text: 'Ο κωδικός επιβεβαίωσης πρέπει να αποτελείται από 4 ψηφία!',
  your_referral_code_is: 'Ο κωδικός σου είναι',
  coupon_code_has_been_copied_to_the_clipboard: 'Ο κωδικός του κουπονιού αντιγράφηκε στο πρόχειρο.',
  my_account: 'Ο λογαριασμός μου',
  products_volume: 'Όγκος προϊόντων',
  instructions_: 'Οδηγίες',
  street_: 'Οδός',
  my_numbers: 'Οι αριθμοί μου',
  where_shoud_we_bring: 'Που να στο φέρουμε;',
  my_addresses: 'Οι διευθύνσεις μου',
  your_orders: 'Οι παραγγελίες σου',
  the_points_you_earn_are: 'Οι πόντοι που κερδίζεις είναι:',
  terms_of_personalization: 'Όροι Εξατομίκευσης',
  terms_: 'Όροι χρήσης κι εξατομίκευσης',
  contest_terms: 'Όροι διαγωνισμού',
  floor_: 'Όροφος',
  not_now: 'Όχι τώρα',
  no_do_not_want: 'Όχι, δεν θέλω',
  address_comments_example: 'π.χ. κτήριο Β, είσοδος από το πλάι, προσοχή σκύλος...',
  order_and_win: 'Παράγγειλε και κέρδισε',
  orders_: 'Παραγγελίες',
  order_delivery_in: 'Παράδοση παραγγελίας σε:',
  please_try_again_later: 'Παρακαλούμε δοκίμασε ξανά σε λίγο',
  please_add_it: 'Παρακαλούμε πρόσθεσε την εκ νέου',
  receiving_your_order: 'Παραλαμβάνουμε την παραγγελία σου!',
  click_here: 'Πάτα εδώ',
  click_here_to_add_comment: 'Πάτα εδώ για να προσθέσεις σχόλιο',
  environmental_fee: 'Περιβαλλοντικό τέλος',
  description_: 'Περιγραφή',
  area_: 'Περιοχή',
  more_: 'Περισσότερα',
  tell_us_what_you_thing_and_earn: 'Πες μας τη γνώμη σου και κέρδισε',
  back_to: 'Πίσω',
  back_to_products: 'Πίσω στα προϊόντα',
  back_to_shop: 'Πίσω στο κατάστημα',
  type_your_comment_here: 'Πληκτρολόγησε εδώ το σχόλιο σου',
  type_your_code_here: 'Πληκτρολόγησε εδώ τον κωδικό σου',
  informations_: 'Πληροφορίες',
  info_for_shop: 'Πληροφορίες για το κατάστημα',
  informations_and_settings: 'Πληροφορίες και ρυθμίσεις',
  shop_info: 'Πληροφορίες καταστήματος',
  coupon_info: 'Πληροφορίες κουπονίου',
  payment_: 'Πληρωμή',
  payment_with: 'Πληρωμή με',
  payment_with_card: 'Πληρωμή με κάρτα',
  payment_with_cash: 'Πληρωμή με μετρητά',
  town_: 'Πόλη',
  town_area: 'Πόλη / Περιοχή',
  points_: 'Πόντοι',
  points_uppercase: 'ΠΟΝΤΟΙ',
  points_lowercase: 'πόντοι',
  the_points: 'πόντους',
  when_do_you_want_to_receive: 'Πότε θες να το παραλάβεις;',
  where_can_i_find_code: 'Που μπορώ να βρω κωδικό;',
  where_should_we_deliver_it: 'Που να στο φέρνουμε;',
  accept_gift_until_deadline: 'Πρέπει να αποδεχτείς το δώρο μέχρι _ACCEPTANCE_DEADLINE',
  scheduled_: 'Προγραμματισμένες',
  system_default: 'Προεπιλογή συστήματος',
  previous_: 'Προηγούμενες',
  products_: 'Προϊόντα',
  add_new_address: 'Πρόσθεσε νέα διεύθυνση',
  add_products_and_earn: 'Πρόσθεσε προϊόντα και κέρδισε',
  add_your_location: 'Πρόσθεσε την τοποθεσία σου',
  addition_: 'Προσθήκη',
  add_new_with_other_options: 'Προσθήκη νέου με άλλες επιλογές',
  add_to_cart: 'Προσθήκη στο καλάθι',
  products_addition: 'Προσθήκη υλικών',
  invite_friends: 'Προσκάλεσε φίλους',
  bring_a_friend: 'Πρόσκληση φίλων',
  privacy_policy: 'Προστασία Δεδομένων',
  recent_orders: 'Πρόσφατες παραγγελίες',
  offers_: 'Προσφορές',
  temporarily_closed: 'Προσωρινά Κλειστό',
  recommendations_: 'Προτάσεις',
  recommended_: 'Προτεινόμενη',
  i_suggest: 'Προτείνω:',
  profile_: 'Προφίλ',
  what_did_you_like: 'Τι σου άρεσε;',
  what_did_you_not_like: 'Τι δεν σου άρεσε;',
  how_was_the_box_delivery: 'Πώς ήταν η διανομή από το ΒΟΧ;',
  how_was_the_delivery: 'Πώς ήταν η διανομή;',
  how_was_your_order: 'Πώς ήταν η παραγγελία σου;',
  what_do_u_think_about_box: 'Πώς σου φαίνεται το ΒΟX;',
  settings_: 'Ρυθμίσεις',
  bags_with_charge: 'Σακούλες με χρέωση',
  its_worth_it_for_you: 'Σας συμφέρει',
  in_progress: 'Σε εξέλιξη',
  thank_you_for_choosing_us: 'Σε ευχαριστούμε που επέλεξες το BOX!',
  today_: 'Σήμερα',
  dark_mode: 'Σκούρα εμφάνιση',
  home_: 'Σπίτι',
  send_it: 'Στείλε την!',
  invoice_details: 'Στοιχεία Τιμολογίου',
  user_details: 'Στοιχεία χρήστη',
  congrats_: 'Συγχαρητήρια!',
  paticipations_: 'συμμετοχές',
  participation_: 'συμμετοχή',
  login_to_continue: 'Συνδέσου για να συνεχίσεις!',
  login_with_your_mobile_or_email:
    'Συνδέσου με το κινητό σου ή το email σου. Αν δεν έχεις λογαριασμό θα σου φτιάξουμε ένα στο λεπτό!',
  combine_and_win: 'Συνδύασε και κέρδισε',
  next_: 'Συνέχεια',
  continue_to_shop: 'Συνέχεια στο κατάστημα',
  continue_without_card: 'Συνέχεια χωρίς κάρτα',
  total_: 'Σύνολο',
  products_total: 'Σύνολο προϊόντων',
  you_will_soon_receive_order_progress_notification:
    'Σύντομα θα λάβεις ειδοποίηση για την εξέλιξη της παραγγελίας σου!',
  coming_soon: 'Σύντομα κοντά σου!',
  drag_the_bar_and_start_earning: 'Σύρε τη μπάρα κι άρχισε να κερδίζεις!',
  comment_: 'Σχόλιο',
  my_products: 'Τα προϊόντα μου',
  sorting_: 'Ταξινόμηση',
  postal_code: 'Ταχυδρομικός Κώδικας',
  final_order_price: 'Τελική τιμή παραγγελίας',
  final_products_price: 'Τελική τιμή προϊόντων',
  contact_by_phone: 'Τηλεφωνική επικοινωνία',
  company_telephone: 'Τηλέφωνο εταιρίας',
  shop_telephone: 'Τηλέφωνο καταστήματος',
  box_hour_ended_for_today: 'Το ΒΟΧ Hour έληξε για σήμερα',
  my_box: 'Το δικό μου BOX',
  gift_will_be_given_to_next_candidate: 'Το δώρο θα το παραλάβει ο επόμενος επιλαχόντας.',
  your_cart_is_empty: 'Το καλάθι σου είναι άδειο!',
  the_shop_does_not_serve_scheduled_orders: 'Το κατάστημα δεν εξυπηρετεί προγραμματισμένες παραγγελίες.',
  the_shop_cannot_serve_you: 'Το κατάστημα δεν μπορεί να σε εξυπηρετήσει',
  the_shop_closed: 'Το κατάστημα έκλεισε',
  the_shop_can_serve_scheduled_order: 'Το κατάστημα μπορεί να εξυπηρετήσει προγραμματισμένη παραγγελία.',
  the_shop_may_not_be_serving_you:
    'Το κατάστημα μπορεί να μην σας εξυπηρετεί, κάνετε σύνδεση για να δείτε καταστήματα στην περιοχή σας!',
  closed_shop: 'Το κατάστημα προσωρινά δεν είναι διαθέσιμο.',
  the_coupon_does_not_meet_all_redemption_criteria_on_this_order:
    'Το κουπόνι δεν πληροί όλα τα κριτήρια εξαργύρωσης σε αυτή την παραγγελία.',
  email_field_is_required: 'Το πεδίο Email είναι υποχρεωτικό',
  number_field_is_required: 'Το πεδίο Αριθμός είναι <strong>υποχρεωτικό</strong>',
  card_number_field_accepts_only_numbers: 'Το πεδίο Αριθμός Κάρτας δέχεται μόνο αριθμούς',
  card_number_field_is_required: 'Το πεδίο Αριθμός Κάρτας είναι υποχρεωτικός',
  address_field_is_invalid: 'Το πεδίο Διεύθυνση δεν είναι σωστό',
  activity_field_is_required: 'Το πεδίο Δραστηριότητα είναι <strong>υποχρεωτικό</strong>',
  comapny_name_field_is_required: 'Το πεδίο Επωνυμία επιχείρησης είναι <strong>υποχρεωτικό</strong>',
  name_at_bell_max_chars: 'Το πεδίο Κουδούνι δεν μπορεί να ξεπερνάει τους',
  name_at_bell_required: 'Το πεδίο Κουδούνι είναι υποχρεωτικό',
  street_field_is_required: 'Το πεδίο Οδός είναι υποχρεωτικό',
  floor_required: 'Το πεδίο Όροφος είναι υποχρεωτικό',
  area_field_is_invalid: 'Το πεδίο Περιοχή δεν είναι σωστό',
  town_area_required: 'Το πεδίο Πόλη / Περιοχή είναι υποχρεωτικό',
  town_field_is_invalid: 'Το πεδίο Πόλη δεν είναι σωστό',
  postal_code_field_is_invalid: 'Το πεδίο Ταχυδρομικός Κώδικας δέν είναι σωστό',
  company_telephone_field_is_required: 'Το πεδίο Τηλέφωνο εταιρίας είναι <strong>υποχρεωτικό</strong>',
  tk_required: 'Το πεδίο ΤΚ είναι υποχρεωτικό',
  order_has_maximum_discount: 'Το ποσό της παραγγελίας σου έχει ήδη λάβει μέγιστη δυνατή έκπτωση.',
  the_product_includes_env_fee: 'Το προϊόν περιλαμβάνει περιβαλλοντικό τέλος',
  select_receive_time: 'Επιλογή επιθυμητής ώρας παραλαβής',
  asap_: 'Το συντομότερο',
  asap_extended: 'Το συντομότερο δυνατόν',
  not_more_than_500_characters: 'Το σχόλιο σου πρέπει να μην ξεπερνάει τους 500 χαρακτήρες!',
  not_more_than_1500_characters: 'Το σχόλιο σου πρέπει να μην ξεπερνάει τους 1500 χαρακτήρες!',
  contact_telephone_is_invalid: 'Το τηλέφωνο επικοινωνίας δεν είναι σωστό',
  contact_telephone_required: 'Το τηλέφωνο επικοινωνίας είναι υποχρεωτικό',
  its_in_your_list_of_active_coupons: 'Υπάρχει στην λίστα με τα ενεργά κουπόνια σου!',
  submit_: 'Υποβολή',
  order_cost_calculation: 'Υπολογισμός κόστους παραγγελίας',
  filters_: 'Φίλτρα',
  make_your_first_order_and_participate: 'Κάνε τώρα την πρώτη σου παραγγελία και ξεκίνα να μαζεύεις συμμετοχές.',
  first_step_is_done: 'Το πρώτο βήμα έγινε!',
  make_it_your_own: 'Φτιάξτο όπως θέλεις',
  characters_: 'χαρακτήρες',
  service_fee: 'Χρέωση υπηρεσίας',
  delivery_time: 'Χρόνος παράδοσης',
  without_expiration: 'Χωρίς λήξη',
  no_: 'Όχι',
  no_comment: 'Χωρίς σχόλιο',
  shopping_: 'Ψώνια',
  hours_: 'ώρες',
  hour_: 'ώρα',
  delvery_hours: 'Ωράριο Διανομής',
  discount_lowercase: 'έκπτωση',
  more_products: 'ακόμα προϊόντα',
  from_points_and_coupons: 'από πόντους και κουπόνια',
  first_name: 'Όνομα',
  cosmote_id_email: 'Email Cosmote id',
  cosmote_id_mobile: 'Κινητό Cosmote id',
  mobile_numbers_included_in_your_cosmote_id: 'αριθμούς κινητού που συμπεριλαμβάνονται στο COSMOTE id σου',
  friends_: 'φίλους',
  you_can_invite_up_to: 'Μπορείς να προσκαλέσεις μέχρι',
  cookies_toggle_title_1: 'Απαραίτητα και Λειτουργικότητας',
  cookies_toggle_title_2: 'Επίδοσης',
  cookies_toggle_title_3: 'Στόχευσης/διαφήμισης',
  cookies_toggle_title_4: 'Βελτιστοποιήση εμπειρίας',
  cookies_toggle_description_1:
    'Τα cookies αυτά είναι τεχνικά απαραίτητα για την πραγματοποίηση της σύνδεσης στον ιστότοπο ή για την παροχή της υπηρεσίας διαδικτύου την οποία έχετε ζητήσει. Τα cookies αυτής της κατηγορίας δεν μπορούν να απενεργοποιηθούν. Εάν ρυθμίσετε τον browser σας, ώστε να μπλοκάρει τη χρήση αυτών των cookies η ιστοσελίδα ή ορισμένα τμήματα αυτής δεν θα λειτουργούν.',
  cookies_toggle_description_2:
    'Bοηθούν στο να κατανοήσουμε πώς αλληλεπιδρούν οι επισκέπτες με τις σελίδες συλλέγοντας συγκεντρωτικές πληροφορίες που δεν ταυτοποιούν άμεσα κάποιον επισκέπτη.',
  cookies_toggle_description_3:
    'Χρησιμοποιούνται για την παροχή προσωποποιημένου περιεχομένου στον επισκέπτη και τη διενέργεια ή τον έλεγχο στοχευμένης διαφημιστικής καμπάνιας.',
  cookies_toggle_description_4:
    'Επιτρέπουν στην ιστοσελίδα να ανακαλεί πληροφορίες που έχει συμπληρώσει ο επισκέπτης σε πεδία, προκειμένου να διευκολύνει την πλοήγησή του.',
  add_new_card_info_text:
    'Μπορείς να προσθέσεις και να αποθηκεύσεις κάρτες για τις online πληρωμές σου κατά την ολοκλήρωση μιας παραγγελίας',
  add_new_sm_card_info_text:
    'Μπορείς να προσθέσεις και να αποθηκεύσεις κάρτες Supermarket κατά την παραγγελία σου στα καταστήματα που τις υποστηρίζουν',
  delete_profile_text:
    'Εδώ μπορείς να διαγράψεις το ΒΟΧ προφίλ σου. Αυτή η ενέργεια είναι μόνιμη και μη αναστρέψιμη, ενώ μετά τη διαγραφή του προφίλ σου, θα πρέπει να δημιουργήσεις λογαριασμό εκ νέου',
  language_: 'Γλωσσά: Ελληνικά (GR)',
  my_profile: 'Το προφίλ μου',
  contests_text:
    'Εδώ μπορείς να βλέπεις τους διαγωνισμούς στους οποίους κέρδισες και να ενημερώνεσαι για όλες τις απαραίτητες πληροφορίες',
  rewards_coupons: 'Έχω κουπόνι δώρου',
  supermarket_cards_text:
    'Μπορείς να δεις τις supermarket κάρτες σου, τους πόντους σου, να τις χρησιμοποιήσεις για τις online αγορές σου, αλλά και στα φυσικά καταστήματα της αγαπημένης σου αλυσίδας supermarket',
  payment_cards: 'Κάρτες πληρωμών',
  payment_cards_text:
    'Μπορείς να προσθέσεις και να αποθηκεύσεις κάρτες για τις online πληρωμές σου κατά την ολοκλήρωση μιας παραγγελίας σου. Μπορείς να αφαιρέσεις μία κάρτα σου, πατώντας “Διαγραφή”',
  contact_data_text:
    'Μπορείς να επεξεργαστείς τον αριθμό κινητού σου για να μπορούμε να επικοινωνήσουμε μαζί σου για την παραγγελία σου.',
  user_details_text: 'Μπορείς να επεξεργαστείς τα προσωπικά σου στοιχεία, όποια στιγμή θέλεις',
  where_should_we_deliver_them: 'Πού να στα φέρουμε',
  add_new_address_text: 'Πρόσθεσε την διεύθυνση που θέλεις να παραλάβεις το φαγητό σου',
  comments_: 'Σχόλια',
  tk_: 'ΤΚ',
  you_have_totally_won: 'Έχεις κερδίσει συνολικά',
  account_personalisation_terms_text:
    'Θέλουμε να σε ενημερώνουμε στο e-mail και στο κινητό σου για όλα τα νέα του BOX, για να μην χάνεις',
  account_personalisation_terms_option_1: 'Συμφωνώ να λαμβάνω προτάσεις βασισμένες στις προτιμήσεις μου.',
  account_personalisation_terms_option_2: 'Δεν συμφωνώ να λαμβάνω προτάσεις βασισμένες στις προτιμήσεις μου.',
  new_shops_to_try: 'Nέα καταστήματα που θες να δοκιμάσεις!',
  discounts_coupons_and_offers: 'Eκπτώσεις, κουπόνια και μεγάλες προσφορές',
  button_for_referral_code_copy: 'Κουμπί για αντιγραφή του Κωδικού Αναφοράς',
  mobile_confirmation: 'Επιβεβαίωση κινητού',
  phone_verification_dialog_description_1:
    'Σου έχουμε στείλει έναν κωδικό με SMS στο _FORMATTED_PHONE, παρακαλούμε συμπλήρωσε αυτόν τον κωδικό εδώ',
  phone_verification_dialog_description_2: 'Πρόσθεσε τον αριθμό κινητού που χρησιμοποιείς για την ταυτοποίησή σου.',
  for_every_problem_call_our_team: 'Για οποιοδήποτε πρόβλημα, μπορείς να καλέσεις την ομάδα μας στο',
  every_day_time_for_help: ', κάθε μέρα, 07:00 - 03:00, για να σε βοηθήσει.',
  delete_profile_dialog_text_1:
    'Πρόκειται να διαγράψεις το ΒΟΧ προφίλ σου. \nΑυτή η ενέργεια είναι μόνιμη και μη αναστρέψιμη.',
  delete_profile_dialog_text_2: 'Μετά τη διαγραφή του προφίλ σου, θα πρέπει να δημιουργήσεις λογαριασμό εκ νέου.',
  delete_profile_dialog_text_3: 'Επιθυμείς να διαγράψεις το προφίλ σου;',
  are_you_sure_for_address_deletion: 'Είσαι σίγουρος ότι θέλεις να διαγράψεις τη συγκεκριμένη διεύθυνση;',
  you_do_not_have_previous_orders: 'Δεν έχεις προηγούμενες παραγγελίες.',
  choose_and_start_now: 'Διάλεξε τι σου αρέσει από τα καταστήματα του Box και ξεκίνα να παραγγέλνεις τώρα!',
  dont_worry_for_closed_shop:
    'Μην ανησυχείς, μπορείς πάντα να παραγγέλνεις από τα καλύτερα καταστήματα που σου προσφέρει το BOX!',
  you_have_won: 'Έχεις κερδίσει:',
  thank_you_for_choosing_box: 'Σε ευχαριστούμε που επέλεξες το ΒΟΧ!',
  contact_with_shop: 'Επικοινώνησε με το κατάστημα',
  thank_you: 'Ευχαριστούμε!',
  tell_us_your_opinion_title: 'Πες μας τη γνώμη σου!',
  tell_us_your_opinion: 'Πες μας τη γνώμη σου',
  take_away_from_shop: 'Παραλαβή από το κατάστημα',
  points_analysis: 'Ανάλυση πόντων',
  points_from_the_shop: 'πόντους από το _SHOP_NAME',
  your_order: 'H παραγγελία σου',
  shipped_at_your_door: 'Έφθασε στην πόρτα σου την:',
  it_will_be_ready_for_pickup_in: 'Θα είναι έτοιμη για παραλαβή σε:',
  it_will_be_at_your_door: 'Θα είναι στην πόρτα σου:',
  it_will_be_at_your_door_in: 'Θα είναι στην πόρτα σου σε:',
  upon_completion_of_your_order_you_won: 'Συγχαρητήρια! Με την ολοκλήρωση της παραγγελίας σου κέρδισες…',
  earn_better_gb_packs_from_whatsup_student_for_the_msisdn_number:
    'Κέρδισε καλύτερα πακέτα GB από το What’s Up Student για τον αριθμό _MSISDN_NUMBER!',
  you_will_be_informed_when_you_get_the_gb_on_the_number: 'Θα ενημερωθείς με SMS μόλις πάρεις τα GB στον αριθμό',
  choose_the_package_you_want_and_you_will_have_it_after_completing_your_order:
    'Διάλεξε τώρα το πακέτο που θέλεις και θα το έχεις αμέσως μετά την ολοκλήρωση της παραγγελίας σου.',
  you_will_get_the_gb_on: 'Θα πάρεις τα GB στο',
  i_want_it: 'Το θέλω',
  in_female: 'στην',
  your_: 'σου',
  watch_your_order_live_on_the_map: 'θα μπορείς να παρακολουθείς live \nτην παραγγελία σου στο χάρτη!',
  your_order_couldnt_be_served_due_to_deliveryman_unavailability:
    'Δυστυχώς η παραγγελία σου δεν μπόρεσε να εξυπηρετηθεί λόγω μη διαθεσιμότητας διανομέα.',
  dont_worry_the_refund_has_already_been_processed: 'Μην ανησυχείς, έχει δρομολογηθεί ήδη η επιστροφή χρημάτων.',
  dont_worry_your_money_will_be_returned:
    'Μην ανησυχείς! Tα χρήματά σου θα αποδεσμευτούν άμεσα και θα επιστραφούν στην κάρτα σου.',
  want_to_earn_more: 'Θες να κερδίζεις περισσότερο;',
  code_: 'Κωδικός:',
  in_box_you_always_win: 'Στο BOX κερδίζεις πάντα!',
  the_available_packages_title: 'Τα διαθέσιμα πακέτα για segment_title',
  enter_your_coupon_code_and_earn:
    'Πληκτρολόγησε τον κωδικό κουπονιού σου, και κέρδισε έκπτωση στην παραγγελία σου ή πόντους δώρο!',
  you_have_to_redeem: 'Έχεις προς εξαργύρωση:',
  start_adding_products_and_earn_points:
    'Ξεκίνα να προσθέτεις τα προϊόντα που σου αρέσουν και να κερδίζεις πόντους με την παραγγελία σου!',
  this_action_will_remove_the_offer_from_the_cart:
    'Αυτή η ενέργεια θα αφαιρέσει την προσφορά από το καλάθι. Είσαι σίγουρος;',
  this_action_will_remove_the_product_from_the_cart:
    'Αυτή η ενέργεια θα αφαιρέσει το προϊόν από το καλάθι. Είσαι σίγουρος;',
  offer_cost_is_excluded: '*Το κόστος της προσφοράς εξαιρείται',
  you_have_free_delivery: 'Έχεις δωρεάν παράδoση!',
  fall_short_one_for_free_delivery: 'Υπολείπεται _PRICE_TEXT για δωρεάν παράδοση.',
  fall_short_many_for_free_delivery: 'Υπολείπονται _PRICE_TEXT για δωρεάν παράδοση.',
  fall_short_many_for_delivery: 'Υπολείπονται _PRICE_TEXT για παράδοση με μόνο _NEXT_FEE_TIER_TEXT.',
  plus_points: ' +_POINTS πόντοι',
  x_points: 'x_POINTS πόντοι',
  fall_short_one_for_min_delivery_price: 'Υπολείπεται _PRICE_TEXT για την ελάχιστη παραγγελία!',
  fall_short_many_for_min_delivery_price: 'Υπολείπονται _PRICE_TEXT για την ελάχιστη παραγγελία!',
  product_maximum_purchase_limit_reached: 'Εχεις φτάσει το μέγιστο όριο αγοράς αυτού του προϊόντος.',
  products_maximum_allowed_volume_limit_reached:
    'Έχεις φτάσει στο μέγιστο επιτρεπόμενο όριο όγκου προϊόντων για Express παράδοση!',
  should_add_one_more_ingredient_for_order_proceed:
    'Πρέπει να προσθέσεις ακόμη _INGREDIENT_NUM υλικό για να προχωρήσεις με την παραγγελία σου.',
  should_add_more_ingredients_for_order_proceed:
    'Πρέπει να προσθέσεις ακόμη _INGREDIENT_NUM υλικά για να προχωρήσεις με την παραγγελία σου.',
  should_add_ingredients_in_products_for_order_proceed:
    'Πρέπει να προσθέσεις υλικά στα προϊόντα products_names για να προχωρήσεις με την παραγγελία σου',
  you_can_only_add_one_dfy_offer_per_order:
    'Μπορείς να προσθέσεις μόνο μία προσφορά Magenta Moments ανά παραγγελία. Εάν θέλεις να συνεχίσεις με την προσθήκη άλλης Magenta Moments προσφοράς, θα αφαιρεθεί αυτόματα από το καλάθι σου αυτή που υπάρχει ήδη.',
  cart_: 'Καλάθι',
  delivery_in_area: 'Delivery στην περιοχή',
  shop_will_give_you_all_info: 'Το κατάστημα θα σου δώσει όλες τις πληροφορίες για το φαγητό και την παρασκευή του.',
  if_you_have_allergies_contact_with_shop:
    'Αν έχεις αλλεργίες ή άλλους διατροφικούς περιορισμούς, και θέλεις να είσαι σίγουρος πριν BOXάρεις, επικοινώνησε με το κατάστημα στο',
  reviews_counter: 'Αξιολογήσεις (_REVIEWS_COUNTER)',
  delivery_fee_colon: 'Αξία διανομής:',
  afm_colon: 'ΑΦΜ:',
  gemh_colon: 'ΓΕΜΗ:',
  want_: 'Θέλω...',
  in_the_mood_for: 'Έχω όρεξη για...',
  with_brew: '…με ποικιλία…',
  and_I_want_it_to_have: '...και θέλω να έχει...',
  shop_address: 'Διεύθυνση καταστήματος:',
  company_headquarters: 'Έδρα επιχείρησης:',
  company_name: 'Επωνυμία επιχείρησης',
  company_name_colon: 'Επωνυμία επιχείρησης:',
  delivery_method_in_time: '_DELIVERY_METHOD σε _TIME',
  delivery_in_time: 'Delivery σε _TIME',
  take_away_in_time: 'Take away σε _TIME',
  takeaway_: 'Takeaway',
  the_takeaway_choice_from: 'Η επιλογή takeaway από',
  the_shop_is_unavailable: 'το κατάστημα δεν είναι διαθέσιμη',
  all_: 'Όλες',
  earn_: 'Κέρδισε',
  last_redemption: 'Τελευταία εξαργύρωση:',
  you_have_a_balance: 'Έχεις υπόλοιπο:',
  search_category_or_product: 'Αναζήτησε κατηγορία ή προϊόν...',
  search_product_or_ingredient: 'Αναζήτησε προϊόν ή υλικό...',
  includes_fee: 'Περιλαμβάνει τέλος',
  you_have_chosen: 'Έχεις επιλέξει:',
  order_from_shop_and_give_your_reviews:
    'Παράγγειλε από το κατάστημα ώστε να μπορείς να δίνεις τις δικές σου αξιολογήσεις και να κερδίζεις πόντους!',
  you_can_see_more_info: 'Μπορείς να δεις περισσότερες πληροφορίες',
  we_provide_this_offer_in_partnership_with_dfy:
    'Παρέχουμε τη συγκεκριμένη προσφορά σε συνεργασία με το Magenta Moments. Στην ολοκλήρωση της παραγγελίας σου, θα σου ζητηθεί κωδικός Magenta Moments.',
  learn_how_to_win_more: 'Μάθε εδώ πως θα κερδίζεις περισσότερα',
  until_now_you_have_won: 'Mέχρι τώρα έχεις κερδίσει',
  the_points_capital: 'Πόντους',
  the_shop_does_not_serve_this_address:
    'Το κατάστημα δεν εξυπηρετεί αυτή την διεύθυνση. Mην ανησυχείς όμως, μπορείς να βρεις πολλές ακόμα επιλογές στην περιοχή σου.',
  the_shop_cannot_serve_you_due_to_unavailable_time:
    'Λόγω μη διαθέσιμου χρόνου, το κατάστημα δεν μπορεί να σε εξυπηρετήσει. Μπορείς να παραγγείλεις από άλλο κατάστημα.',
  for_the_date: 'για την _DATE',
  you_can_add_only_one_dfy_offer_per_order: 'Μπορείς να προσθέσεις μόνο μια προσφορά "Magenta Moments" ανά παραγγελία.',
  register_login: 'Εγγραφή/Σύνδεση',
  your_changes_have_been_saved: 'Οι αλλαγές σου αποθηκεύτηκαν.',
  are_you_sure_you_want_to_remove_your_card: 'Είσαι σίγουρος ότι θέλεις να αφαιρέσεις την κάρτα σου;',
  reenter_it_the_next_time_you_wish_to_order_from_a_store:
    'Θα πρέπει να την εισάγεις ξανά την επόμενη φορά που επιθυμείς να παραγγείλεις από κατάστημα _SHOP_NAME',
  'no_stores_were_found_for_this particular_chain_at_your_address':
    'Δεν βρέθηκαν καταστήματα για την συγκεκριμένη αλυσίδα στη διεύθυνση σου.',
  product_search: 'Αναζήτηση προϊόντος…',
  no_delivery_times_available_from_this_store_at_the_moment:
    'Προς το παρόν δεν υπάρχουν διαθέσιμες ώρες παράδοσης από το συγκεκριμένο κατάστημα.',
  selected_time_for_scheduling_an_order_is_unavailable:
    'H ώρα που έχεις επιλέξει για προγραμματισμό παραγγελίας δεν είναι διαθέσιμη από το κατάστημα.',
  you_can_choose_another_delivery_time: 'Μπορείς να επιλέξεις κάποια άλλη ώρα παράδοσης ή να συνεχίσεις στο μενού.',
  you_can_find_other_shops_and_order_from_box:
    'Μπορείς όμως να βρεις άλλα καταστήματα, να παραγγείλεις μέσω του BOX και να συνεχίσεις να κερδίζεις!',
  are_you_sure_your_address_doesnt_include_a_number:
    'Είσαι σίγουρος ότι η διεύθυνση σου δεν περιλαμβάνει αριθμό; Μπορείς να προσθέσεις οδηγίες παράδοσης στα σχόλια της παραγγελίας σου.',
  and_up_to_x_additional_ingredients: '(Και έως _MAX_ITEMS επιπλέον υλικά)',
  the_x_free: '(το _FREE_CHOICES δωρεάν)',
  the_x_free_many: '(τα _FREE_CHOICES δωρεάν)',
  and_up_to_x_additional_ingredients_the_x_free: '(Και έως _MAX_ITEMS επιπλέον υλικά, το _FREE_CHOICES  δωρεάν)',
  and_up_to_x_additional_ingredients_the_x_free_many: '(Και έως _MAX_ITEMS επιπλέον υλικά, τα _FREE_CHOICES  δωρεάν)',
  up_to_x_time_per_order: 'Μέχρι _MAX_ITEMS_PER_ORDER φορά ανά παραγγελία',
  up_to_x_times_per_order: 'Μέχρι _MAX_ITEMS_PER_ORDER φορές ανά παραγγελία',
  with_minimum_order_price: 'Με ελάχιστη παραγγελία _PRICE',
  above_min_price_free_delivery: '‎• Πάνω από _LAST_TIER_MIN_PRICE_TEXT: Delivery δωρεάν',
  above_min_price_delivery: '‎• Πάνω από _LAST_TIER_MIN_PRICE_TEXT: Delivery _LAST_TIER_FEE',
  below_above_limit_delivery_fee: '‎• _BOTTOM_LIMIT_TEXT - _UPPER_LIMIT_TEXT: Delivery _FEE_TEXT',
  below_limit_delivery_fee: '‎• Κάτω από _UPPER_LIMIT_TEXT: Delivery _FEE_TEXT',
  the_final_delivery_cost_depends_on_your_cart_amount:
    'Το τελικό κόστος του Delivery (_DEL_FEES_TEXT_SUM) εξαρτάται από το ποσό του καλαθιού σου:',
  contact_telephone: 'Τηλέφωνο επικοινωνίας',
  type_a_contact_telephone: 'Πληκτρολόγησε ένα τηλέφωνο επικοινωνίας',
  the_characters: 'Οι χαρακτήρες',
  are_invalid: 'δεν είναι έγκυροι',
  must_select_payment_with_card_for_points_redemption:
    'Πρέπει να επιλέξεις πληρωμή με κάρτα για να εξαργυρώσεις του πόντους σου.',
  points_redemption_is_not_combined_with_the_selected_coupon:
    'Η εξαργύρωση πόντων δε συνδυάζεται με το κουπόνι που έχει ήδη επιλεχθεί.',
  if_you_prefer_points_redemption_remove_coupon:
    'Αν προτιμάς εξαργύρωση πόντων, θα χρειαστεί να αφαιρέσεις το κουπόνι.',
  connect_your_card_with_the_box: 'Έχεις _CARD_NAME Σύνδεσέ τη με το ΒΟΧ και απόλαυσε όλα τα προνόμια!',
  redeem_points_and_earn_discount: 'Εξαργύρωσε _POINTS πόντους _CARD_NAME και κέρδισε έκπτωση _PRICE!',
  redeeming_points_and_earning_discount: 'Εξαργυρώνεις _POINTS πόντους _CARD_NAME και κερδίζεις έκπτωση _PRICE!',
  a_previous_requested_order_has_not_yet_been_completed:
    'Μια προηγούμενη παραγγελία σου για την οποία έχεις ζητήσει εξαργύρωση πόντων δεν έχει παραδοθεί ακόμα. Μπορείς να εξαργυρώσεις τους πόντους σου για μια νέα παραγγελία μετά την παράδοση της προηγούμενης.',
  and_you_win: 'και κέρδιζεις',
  you_have_a_discount: 'Έχεις έκπτωση!',
  to_get_the_discount_we_set_payment_by_card_as_the_payment_method:
    'Για να πάρεις την έκπτωση, ορίσαμε πληρωμή με κάρτα ως τρόπο πληρωμής και προσυμπληρώσαμε το εκπτωτικό κουπόνι.',
  box_points_and: 'BOX πόντους &',
  points_for_your_order: 'πόντους για την παραγγελία σου!',
  with_: 'με',
  pay_online_with_your_card: 'Πλήρωσε οnline με την κάρτα σου!',
  choose_the_amount_you_wish_to_donate:
    'Επίλεξε το ποσό που επιθυμείς να δωρίσεις απο 0,5_CURRENCY ως 20_CURRENCY και θα υπολογιστεί στην τελική τιμή της παραγγελίας.',
  unfortunately_the_store_does_not_serve_this_address:
    'Δυστυχώς το κατάστημα δεν εξυπηρετεί την συγκεκριμένη διεύθυνση. Μπορείς να επιλέξεις μια διεύθυνση που να εξυπηρετείται ή να διαγράψεις αυτή την παραγγελία και να ξεκινήσεις νέα',
  invoice_issue: 'Έκδοση Τιμολογίου',
  bag_quantity_env_fee: '_BAGS_QUANTITY σακούλα (περιβαλλοντικό τέλος _PRICE_TEXT_CURRENCY / σακούλα)',
  bags_quantity_env_fee: '_BAGS_QUANTITY σακούλες (περιβαλλοντικό τέλος _PRICE_TEXT_CURRENCY / σακούλα)',
  points_and_dont_worry_about_carrying_cash_anymore: 'πόντους και μην αγχώνεσαι πια αν θα έχεις πάνω σου μετρητά!',
  card_addition: 'Προσθήκη κάρτας',
  you_must_select_payment_by_card_to_complete_a_discount_coupon:
    'Πρέπει να επιλέξεις πληρωμή με κάρτα για να συμπληρώσεις ένα κουπόνι έκπτωσης.',
  do_not_forget: 'Μην ξεχάσεις!',
  please_type_your_code_in_coupon_field: 'Παρακαλούμε γράψε τον κωδικό σου στο πεδίο "Κουπόνι"',
  you_must_enter_a_valid_dfy_code:
    'Για να πάρεις την Magenta Moments προσφορά που έχεις προσθέσει στα προϊόντα σου, πρέπει να συμπληρώσεις έναν έγκυρο κωδικό Magenta Moments.',
  coupon_discount_will_be_removed_from_your_cart:
    'Πατώντας το ΟΚ η έκπτωση του κουπονιού θα αφαιρεθεί από το καλάθι σου.',
  redeem_your_coupon_box_or_other: 'Εξαργύρωσε το κουπόνι σου, BOX ή άλλο!',
  redeem_your_coupon_dfy_or_other: 'Εξαργύρωσε το κουπόνι σου, Magenta Moments ή άλλο!',
  the_new_final_price_of_your_order_is:
    'Οι τιμές για κάποια προϊόντα που είχες στο καλάθι σου έχουν ανανεωθεί. Η νέα τελική τιμή της παραγγελίας σου είναι _PRICE_TEXT.',
  payment_by_card_is_required_for_takeaway_orders:
    'Για παραγγελίες μέσω Take away απαιτείται πληρωμή με κάρτα, οπότε αλλάξαμε αυτόματα τον τρόπο πληρωμής σου',
  min_order_price_for_delivery_is: 'Η τιμή της ελάχιστης παραγγελίας για delivery είναι _PRICE_TEXT.',
  min_order_price_for_takeaway_is: 'Η τιμή της ελάχιστης παραγγελίας για παραλαβή απο το κατάστημα είναι _PRICE_TEXT.',
  your_cart_is_not_sufficient_to_continue_with_a_delivery:
    'Το καλάθι σου δεν επαρκεί για να συνεχίσεις σε delivery. Πρόσθεσε επιπλέον προϊόντα από το κατάστημα, ή επίλεξε παραλαβή από το κατάστημα.',
  your_cart_is_not_sufficient_to_continue_with_a_takeaway:
    'Το καλάθι σου δεν επαρκεί για να συνεχίσεις σε παραλαβή απο το κατάστημα. Πρόσθεσε επιπλέον προϊόντα από το κατάστημα, ή επίλεξε delivery.',
  missing_information_from_your_address: 'Λείπουν στοιχεία από τη διεύθυνση σου',
  add_new_card_with_save_in_next_step: 'Προσθήκη νέας κάρτας με\nαποθήκευση, στο επόμενο βήμα',
  add_new_card_without_save_in_next_step: 'Προσθήκη νέας κάρτας χωρίς\nαποθήκευση, στο επόμενο βήμα',
  the_card_pan: 'Την κάρτα _CARD_PAN',
  up_to_gb_for_your_mobile_phone: 'Έως _GB_REWARD_NUMBERGB για το κινητό σου',
  your_available_points_balance_is_not_sufficient:
    'Το υπόλοιπο των διαθέσιμων πόντων σου δεν επαρκεί ώστε να επιλέξεις αυτό το ποσό για εξαργύρωση.',
  your_cart_must_have_at_least_wanted_price:
    'Για να πάρεις _MAX_POINTS_CURRENCY έκπτωση, το καλάθι σου πρέπει να είναι τουλάχιστον _WANTED_PRICE_CURRENCY.',
  order_tomorrow_from_to_time_and_earn:
    'Μπορείς να παραγγείλεις αύριο μεταξύ _TIME_FROM και _TIME_TO και να κερδίσεις _MULTIPLIERπλάσιους πόντους!',
  you_have_already_earned_6x_points_from_your_first_order_in_the_shop:
    'Έχεις ήδη πάρει 6x πόντους από την πρώτη σου παραγγελία στο κατάστημα.',
  earn_discount_benefits: 'Κερδίζεις έκπτωση _BENEFITS_TEXT',
  redeem_coupon_and_earn_benefits: 'Εξαργυρώνεις το κουπόνι _COUPON_CODE και κερδίζεις _BENEFITS_TEXT!',
  redeem_coupon_and_earn_benefits_magenda_moments:
    'Με το Magenta Moments κουπόνι _COUPON_CODE κερδίζεις _BENEFITS_TEXT',
  from_: 'από',
  you_earn_lowercase: 'κερδίζεις',
  you_earn: 'Κερδίζεις',
  points_for: 'πόντους για',
  your_order_from_the_shop: 'την παραγγελία σου από το κατάστημα',
  your_order_from: 'την παραγγελία σου από',
  the_shop: 'το κατάστημα',
  card_confirmation: 'Επιβεβαίωση κάρτας',
  please_fill_in_your_missing_credit_or_debit_card_details:
    'Παρακαλούμε συμπληρώστε τα στοιχεία της πιστωτικής ή χρεωστική σας κάρτας που λείπουν.',
  choose_address: 'Επίλεξε διεύθυνση',
  delete_confirmation: 'Επιβεβαίωση διαγραφής',
  floor_text: 'Όροφος: _FLOOR',
  name_at_bell_text: 'Κουδούνι: _NAME_AT_BELL',
  the_bank_could_not_process_the_payment_request:
    'Η τράπεζα δεν μπόρεσε να επεξεργαστεί το αίτημα πληρωμής. Μην ανησυχείς όμως, εάν χρησιμοποίησες πόντους, δεν εξαργυρώθηκαν, ενώ εάν χρησιμοποίησες κουπόνι, θα είναι ξανά διαθέσιμο για χρήση σε 30’.',
  which_products_would_you_recommend_to_your_friends: 'Ποια προϊόντα θα πρότεινες στους φίλους σου; ',
  which_dish_would_you_recommend_to_your_friends: 'Ποιο πιάτο θα πρότεινες στους φίλους σου;',
  box_is_spreading:
    'Το BOX εξαπλώνεται! Θα είμαστε σε θέση να εξυπηρετήσουμε την περιοχή σου πολύ σύντομα! Επίλεξε μια άλλη διεύθυνση ή πρόσθεσε μια νέα για να δείς καταστήματα που σε εξυπηρετούν.',
  your_card: 'Η _CARD_NAME σου',
  found_x_offers: 'Βρήκαμε _OFFERS_COUNT προσφορές',
  found_x_shops: 'Βρήκαμε _SHOPS_COUNT καταστήματα',
  found_x_items: 'Βρήκαμε _ITEMS_COUNT προϊόντα',
  we_found_your_card:
    'Βρήκαμε την _CARD_NAME σου! Μπορείς να τη χρησιμοποιήσεις για την παραγγελία σου στο ΒΟΧ ώστε να:',
  your_card_is_ready: 'Έτοιμη η _CARD_NAME σου! Μπορείς να τη χρησιμοποιήσεις για την παραγγελία σου στο ΒΟΧ ώστε να:',
  alternatively_: 'εναλλακτικά',
  type_your_email_for_connecting_your_card:
    'Πληκτρολόγησε το Email σου για να τη συνδέσεις με το ΒΟΧ και να απολαμβάνεις όλα τα προνόμια!',
  type_your_card_number_for_connecting_your_card:
    'Πληκτρολόγησε τον αριθμό της για να τη συνδέσεις με το ΒΟΧ και να απολαμβάνεις όλα τα προνόμια!',
  you_already_have_a_shop_card: 'Έχεις ήδη κάρτα _SHOP_NAME;',
  collect_and_redeem_points_from_supermarkets: 'Συλλέγεις & εξαργυρώνεις πόντους από τα supermarket _SHOP_NAME.',
  you_can_also_use_it_in_physical_supermarkets: 'Tη χρησιμοποιείς και στα φυσικά καταστήματα supermarket _SHOP_NAME.',
  we_will_create_a_new_card_for_you_to: 'Θα σου δημιουργήσουμε μια νέα κάρτα, για να:',
  you_can_also_use_it_in_the_online_supermarkets:
    'Tη χρησιμοποιείς και στο ηλεκτρονικό καταστήματα supermarket _SHOP_NAME.',
  dont_worry_you_can_complete_your_order_normally:
    'Δεν έχεις κάρτα _SHOP_NAME; Μην ανησυχείς, μπορείς να ολοκληρώσεις την παραγγελία σου κανονικά!',
  if_you_get_a_card_in_the_future:
    'Εάν αποκτήσεις μια κάρτα στο μέλλον, μπορείς να την εισάγεις αργότερα για να απολαμβάνεις όλα τα προνόμια και τις εκπτώσεις από τα Supermarket _SHOP_NAME.',
  enter_the_mobile_phone_and_create_new_card:
    'Πληκτρολόγησε τον αριθμό του κινητού τηλεφώνου με τον οποίο θέλεις να δημιουργηθεί η νέα _SHOP_NAME _CARD_NAME σου.',
  enter_the_email_and_create_new_card:
    'Πληκτρολόγησε το email με το οποίο θέλεις να δημιουργηθεί η νέα _SHOP_NAME _CARD_NAME σου.',
  redeem_your_card_points_and_get_discounts:
    'Εξαργυρώνεις τους _CARD_NAME πόντους σου και να κερδίζεις εκπτώσεις για τις παραγγελίες σου στα supermarkets _SHOP_NAME!',
  collect_points_from_your_orders_in_supermarkets:
    'Συλλέγεις πόντους από τις παραγγελίες σου στα supermarkets _SHOP_NAME!',
  we_have_sent_you_a_code_to_email:
    'Σου έχουμε στείλει έναν κωδικό στο <strong>_EMAIL</strong>, παρακαλούμε συμπλήρωσε αυτόν τον κωδικό στο παρακάτω πεδίο',
  we_have_sent_you_a_code_with_sms:
    'Σου έχουμε στείλει έναν κωδικό με SMS στο <strong>_PHONE_NUMBER</strong>, παρακαλούμε συμπλήρωσε αυτόν τον κωδικό στο παρακάτω πεδίο.',
  for_any_issue_regarding_the_confirmation_of_your_card:
    'Για οποιοδήποτε θέμα σχετικά με την επιβεβαίωση της κάρτας σου μπορείς να επικοινωνήσεις με τα supermarket _SHOP_NAME στο _SHOP_NUMBER.',
  type_the_pin_code: 'Πληκτρολόγησε τον κωδικό (PIN) της κάρτας σου στο παρακάτω πεδίο.',
  didnt_you_get_the_text: 'Δεν έλαβες το SMS;',
  forgot_your_password: 'Ξέχασες τον κωδικό σου;',
  didnt_you_get_the_email: 'Δεν έλαβες το email;',
  up_to_max_ingredients_free: 'Έως _MAX_ITEMS υλικά, το _FREE_CHOICES δωρεάν',
  up_to_max_ingredients_free_many: 'Έως _MAX_ITEMS υλικά, τα _FREE_CHOICES δωρεάν',
  up_to_max_ingredients: 'Έως _MAX_ITEMS υλικά',
  free_choices: 'Το _FREE_CHOICES δωρεάν',
  free_choices_many: 'Τα _FREE_CHOICES δωρεάν',
  you_have_exceeded_the_max_ingredients_number: 'Έχεις υπερβεί τον μέγιστο αριθμό υλικών (_MAX_ITEMS).',
  you_have_exceeded_the_max_ingredients_category_number:
    'Έχεις υπερβεί τον μέγιστο αριθμό υλικών (_MAX_ITEMS) της κατηγορίας.',
  you_first_have_to_remove_some_of_the_already_selected:
    'Για να προσθέσεις αυτό το υλικό πρέπει πρώτα να αφαιρέσεις κάποιο από τα ήδη επιλεγμένα',
  you_will_need_to_enable_location_sharing:
    'Θα πρέπει να ενεργοποιήστε την κοινή χρήση τοποθεσίας στις ρυθμίσεις του προγράμματος περιήγησής σας.',
  we_havent_been_able_to_get_your_location_try_again: 'Δεν καταφέραμε να βρούμε την τοποθεσία σου, προσπάθησε ξανά.',
  your_browser_cannot_access_your_location: 'Ο browser σου δεν έχει πρόσβαση στην τοποθεσία σου.',
  something_went_wrong_when_connecting_to_your_cosmote_id:
    'Κάτι πήγε στραβά κατά την σύνδεση με το Cosmote Id σου. Δοκίμασε ξανά αργότερα.',
  by_date: 'Μέχρι τις _DATE',
  expired_at_date: 'Έληξε στις _DATE',
  redeemed_at_date: 'Εξαργυρώθηκε στις _DATE',
  choose_replacement_method: 'Επίλεξε τρόπο αντικατάστασης',
  when_a_product_you_have_ordered_is_not_available:
    'Όταν δεν υπάρχει διαθέσιμο κάποιο προϊόν που έχεις παραγγείλει, επιθυμείς:',
  we_have_sent_you_a_code_by_email_to:
    'Σου έχουμε στείλει έναν κωδικό με email στο _EMAIL, παρακαλούμε συμπλήρωσε αυτόν τον κωδικό εδώ',
  with_the_discount_coupon_the_new_price_of_your_cart_is:
    'Με το εκπτωτικό κουπόνι, η νέα τιμή του καλαθιού σου είναι _CART_PRICE.',
  redeem_dfy_code_and_get_the_pizza_fan_offer:
    'Εξαργύρωσε έναν κωδικό Magenta Moments και πάρε την προσφορά Pizza Fan!',
  redeem_the_code_and_get_the_pizza_fan_offer:
    'Εξαργυρώνεις το κωδικό _COUPON_CODE και παίρνεις την προσφορά Pizza Fan!',
  to_get_discount_your_cart_must_be_at_least:
    'Για να πάρεις _COUPON_DISCOUNT έκπτωση, το καλάθι σου πρέπει να είναι τουλάχιστον _MINIMUM_PRICE.',
  order_tracking: 'Παρακολούθηση παραγγελίας',
  for_every_points_you_redeem_you_get_one_euro_discount:
    'Για κάθε _POINTS πόντους που εξαργυρώνεις κερδίζεις 1_CURRENCY έκπτωση για κάθε _EURO_REDEMPTION_RATE_CURRENCY παραγγελίας',
  the_minimum_order_value_is: 'H ελάχιστη τιμή παραγγελίας είναι',
  dont_worry_you_have_chosen_the_order:
    'Μην ανησυχείς όμως! Επειδή έχεις επιλέξει την <strong>αποκλειστική προσφορά</strong> μας, μπορείς να στείλεις κανονικά την παραγγελία σου!',
  dfy_offers_are_available_for_all_cosmote_customers:
    'Οι προσφορές Magenta Moments είναι διαθέσιμες για όλους τους πελάτες κινητής και σταθερής COSMOTE TELEKOM και COSMOTE TV.',
  you_can_take_your_code_from_my_cosmote_app:
    "Μπορείς να πάρεις τον κωδικό σου από το MY COSMOTE APP, WHAT'S UP APP ή στέλνοντας κενό SMS στο 19019 (χρέωση 0,20_CURRENCY, συμπεριλαμβανομένου ΦΠΑ)",
  dfy_offer: 'Magenta Moments Προσφορά',
  please_choose_a_payment_method: 'Παρακαλούμε επίλεξε τρόπο πληρωμής.',
  your_password_was_copied_to_the_clipboard: 'Ο κωδικός σου αντιγράφηκε στο πρόχειρο.',
  your_new_card_has_been_created: 'Δημιουργήθηκε η νέα _CARD_NAME σου. Μπορείς να τη δεις',
  '30_percent_discount_has_expired': 'Η έκπτωση 30% έληξε, μείνε συντονισμένος για νέες εκπτώσεις!',
  search_shop: 'Αναζήτησε κατάστημα',
  card_number_trimmed: 'Αρ. Κάρτας:',
  box_points: 'Πόντοι BOX',
  box_coupons: 'Κουπόνια BOX',
  gigabyte_packs: 'Πακέτα Gigabyte',
  add_your_card_when_sending_your_order_and_earn:
    'Πρόσθεσε την κάρτα σου κατά την αποστολή της παραγγελίας σου και κέρδισε +_CLAIMABLE_POINTS πόντους',
  claimable_points_html_template: '<span class="rewards-card-highlighted">+_CLAIMABLE_POINTS πόντοι</span>',
  earned_points_html_template: 'Κέρδισες <span class="rewards-card-highlighted">_EARNED_POINTS πόντους</span>',
  points_for_every_order_html_template:
    '<span class="rewards-card-highlighted">x_MULTIPLIER πόντοι</span> για κάθε παραγγελία!',
  order_something_new: 'Παράγγειλε κάτι καινούργιο',
  earned_from_box_html_template: 'Κέρδισες <span class="rewards-card-highlighted">+_POINTS πόντους</span> από το ΒΟΧ',
  earned_from_friends_html_template:
    'Κέρδισες <span class="rewards-card-highlighted">_EARNED_EUROS</span> από _REFERRALS φίλους',
  for_every_friend_html_template: '<span class="rewards-card-highlighted">_BENEFIT</span> για κάθε φίλο!',
  the_more_you_order_the_more_you_earn:
    'Όσο παραγγέλνεις, τόσο κερδίζεις! Κάνε παραγγελίες και κέρδισε πόντους για εκπτώσεις και GΒ',
  earned_from_explore_many_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελίες Explore',
  earned_from_explore_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελία Explore',
  earned_from_happy_hour_many_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελίες Happy Hour',
  earned_from_happy_hour_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελία Happy Hour',
  earned_from_orders_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελίες',
  earned_from_order_html_template:
    'Έχεις κερδίσει <span class="rewards-card-highlighted">_AMOUNT</span> από _COUNT παραγγελία',
  user_points_for_orders: '_USER_POINTS_CURRENCY για παραγγελίες',
  at_: 'στις',
  the_options_we_recommend_from_the_shop: 'Οι επιλογές που σου προτείνουμε από το _SHOP_NAME είναι: _DISHES.',
  shop_rating_in_location:
    'To κατάστημα _SHOP_NAME στην περιοχή _LOCATION βαθμολογήθηκε με _RATING αστεράκια. Εσύ τι λες;',
  x_hours: '_HOURS ωρών',
  x_hour: '_HOURS ώρας',
  x_minutes: '_MINUTES λεπτών',
  redeem_points_and_earn_up_to_benefits_discount: 'Εξαργύρωσε πόντους και κέρδισε έως _BENEFITS_TEXT έκπτωση',
  min_order_price_is_needed_to_obtain_the_offer: 'Για την απόκτηση της προσφοράς χρειάζονται _MIN_ORDER_PRICE',
  you_will_continue_your_order_without_the_offer:
    'Θα συνεχίσεις την παραγγελίας σου χωρίς την προσφορά _OFFER_NAME γιατί δεν κάλυψες την ελάχιστη παραγγελία, να προχωρήσουμε;',
  you_will_continue_your_order_without_the_offers:
    'Θα συνεχίσεις την παραγγελίας σου χωρίς τις προσφορές _OFFERS_NAME γιατί δεν κάλυψες την ελάχιστη παραγγελία, να προχωρήσουμε;',
  until_date: 'Έως _DATE',
  terms_of_use_anchor: '<a href="_TERMS_URL" target="_blank" rel="noopener noreferrer">όρους χρήσης</a>',
  i_agree_with_terms_of_use_html_template:
    'Συμφωνώ με τους _TERMS_ANCHOR της _SHORT_CARD_NAME και επιθυμώ την χορήγηση και διαβίβαση των στοιχείων μου στα Supermarkets _SM_NAME για την καταχώρηση των πόντων και την απόδοση εκπτώσεων που τυχόν δικαιούμαι.',
  i_wish_to_keep_the_privilege_card_saved:
    'Επιθυμώ να μείνει αποθηκευμένη η κάρτα προνομίων _SHORT_CARD_NAME στην πλατφόρμα του BOX και για τις επόμενες παραγγελίες.',
  i_agree_to_sent_my_details_to_supermarkets:
    'Συμφωνώ με τους _TERMS_ANCHOR και να σταλούν τα στοιχεία μου στα Supermarkets _SM_NAME για την ολοκλήρωση της παραγγελίας μου.',
  processing_of_personal_data_anchor:
    '<a href="_TERMS_URL" target="_blank" rel="noopener noreferrer">επεξεργασία των προσωπικών δεδομένων</a>',
  i_have_been_informed_about_processing_of_my_personal_data:
    'Έχω ενημερωθεί σχετικά με την _DATA_TERMS_ANCHOR μου εκ μέρους του Καταστήματος για την έκδοση και χρήση της _SHORT_CARD_NAME. Έχω ενημερωθεί και συμφωνώ με τους _TERMS_ANCHOR της _SHORT_CARD_NAME.',
  i_wish_to_provide_and_transmit_my_data_to_supermarkets:
    'Επιθυμώ την χορήγηση και διαβίβαση των στοιχείων μου στα Supermarkets _SM_NAME για τη δημιουργία της νέας κάρτας μου.',
  seo_default_description:
    'Παράγγειλε φαγητό online από το BOX. Κάνε τα ψώνια σου online. Μάζεψε πόντους από την παραγγελία σου και εξαργύρωσε τους. Είσαι έτοιμος να BOXάρεις;',
  seo_default_keywords:
    'online delivery app, online παραγγελία app, delivery application, online παραγγελία φαγητού, προσφορές delivery',
  redeem_points_and_earn_discount_2: 'Εξαργύρωσε _POINTS πόντους και κέρδισε _DISCOUNT έκπτωση!',
  and_earn_x_discount: 'και κερδίζεις _DISCOUNT_CURRENCY έκπτωση!',
  personal_data: 'Προσωπικά δεδομένα',
  terms_and_conditions_of_use: 'Όροι και προϋποθέσεις χρήσης',
  privacy_update: 'Ενημέρωση προστασίας προσωπικών δεδομένων',
  trackers_management: 'Διαχείριση των trackers',
  and_get_a_discount: 'και κέρδισε έκπτωση!',
  cookies_info: 'Πληροφορίες για τα cookies',
  cookies_info_description:
    'Χρησιμοποιούμε cookies στον ιστότοπό μας για την ορθή λειτουργία του ιστότοπου, για την παροχή προσωποποιημένων λειτουργιών, για την βελτίωση και για την προσαρμογή διαφημιστικού και άλλου περιεχομένου, ώστε να αντικατοπτρίζει τις ιδιαίτερες ανάγκες και τα ενδιαφέροντά σας. Επίσης χρησιμοποιούμε cookies για να συγκεντρώσουμε στατιστικά στοιχεία που μας επιτρέπουν να αντιληφθούμε πώς οι χρήστες χρησιμοποιούν τον ιστότοπο μας και βοηθούν στο να βελτιώσουμε την δομή και το περιεχόμενό του. Αποδέκτες των δεδομένων που προκύπτουν από την χρήση των cookies ενδέχεται να είναι και εταιρείες διαχείρισης της αποτελεσματικότητας των διαφημιστικών καμπανιών για την εξυπηρέτηση του σκοπού αυτού.',
  necessary_cookies: 'Cookies αναγκαία και λειτουργικότητας',
  necessary_cookies_description:
    'Τα cookies αυτά είναι τεχνικά απαραίτητα για την πραγματοποίηση της σύνδεσης στον ιστότοπο ή για την παροχή της υπηρεσίας διαδικτύου την οποία έχετε ζητήσει. Σε αυτήν την κατηγορία ανήκουν cookies που χρησιμοποιούνται για την αναγνώριση ή/και διατήρηση περιεχομένου που εισάγει ο συνδρομητής ή χρήστης κατά τη διάρκεια μιας σύνδεσης (session) σε ιστότοπο καθ’ όλη τη διάρκεια της συγκεκριμένης σύνδεσης, όπως το «καλάθι αγορών», για τη σύνδεση του συνδρομητή ή χρήστη σε υπηρεσίες που απαιτούν αυθεντικοποίηση, για την ασφάλεια του χρήστη, για την πραγματοποίηση της τεχνικής της κατανομής φορτίου (load balancing) σε μία σύνδεση σε ιστοσελίδα του διαδικτύου, για την επίλυση των τεχνικών σφαλμάτων της ιστοσελίδας, για τη διατήρηση των επιλογών του χρήστη σχετικά με την παρουσίαση του ιστότοπου, π.χ. επιλογή γλώσσας, αποθήκευση ιστορικού αναζητήσεων κτλ., καθώς επίσης και τα cookies που ενεργοποιούνται, προκειμένου να λειτουργήσει η επιλογή της συνομιλίας (chat), που παρέχεται μέσω μιας ιστοσελίδας. Τα cookies αυτής της κατηγορίας δεν μπορούν να απενεργοποιηθούν. Εάν ρυθμίσετε τον browser σας, ώστε να μπλοκάρει τη χρήση αυτών των cookies η ιστοσελίδα ή ορισμένα τμήματα αυτής δεν θα λειτουργούν.',
  performance_cookies: 'Cookies επιδόσεων',
  performance_cookies_description:
    'Αυτά τα cookies συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι επισκέπτες χρησιμοποιούν τον ιστότοπο, για παράδειγμα πόσοι χρήστες τον επισκέφτηκαν, ποιες σελίδες του ιστότοπου επισκέπτονται συχνότερα κτλ. Αυτά τα cookies συλλέγουν συγκεντρωτικές πληροφορίες που δεν ταυτοποιούν άμεσα κάποιον επισκέπτη. Χρησιμοποιούνται αποκλειστικά για τη βελτίωση της λειτουργίας μίας ιστοσελίδας. Για τον σκοπό αυτό χρησιμοποιούμε τους μηχανισμούς Google Analytics και Hotjar.',
  advertising_cookies: 'Cookies στόχευσης/διαφήμισης',
  advertising_cookies_description:
    'Αυτά τα cookies χρησιμοποιούνται για την παροχή περιεχομένου, που ταιριάζει περισσότερο σε εσάς και τα ενδιαφέροντά σας. Μπορεί να χρησιμοποιηθούν για την αποστολή στοχευμένης διαφήμισης/προσφορών, τον περιορισμό προβολών διαφήμισης ή την μέτρηση αποτελεσματικότητας μιας διαφημιστικής καμπάνιας. Επίσης μπορεί να χρησιμοποιηθούν για να θυμόμαστε μέσω ποιου ιστότοπου μάθατε και επισκεφθήκατε την ιστοσελίδα μας, ώστε να καθορίσουμε ποια ηλεκτρονικά κανάλια μάρκετινγκ είναι πιο αποτελεσματικά. Τα cookies αυτά σας αναγνωρίζουν με τεχνικά δεδομένα όπως η IP διεύθυνσή σας, το πρόγραμμα περιήγησής σας και ο τύπος της συσκευής σας. Για τον σκοπό αυτό χρησιμοποιούμε τους μηχανισμούς Facebook Pixel.',
  customer_experience_cookies: 'Cookies βελτιστοποίησης εμπειρίας πελάτη',
  customer_experience_cookies_description:
    'Αυτά τα cookies επιτρέπουν στον ιστοσελίδα να θυμάται τις πληροφορίες που έχεις εισάγει σε συγκεκριμένα πεδία (π.χ. διεύθυνση, γευστικές προτιμήσεις, τελευταίος τρόπος πληρωμής), προκειμένου για την άμεση αναζήτηση αποτελεσμάτων και την καταχώριση παραγγελίας φαγητού. Έτσι, δεν θα χρειαστεί να εισάγεις ξανά τις συγκεκριμένες καταχωρήσεις, οι οποίες θα εμφανίζονται προσυμπληρωμένες κατά τη διάρκεια της περαιτέρω - αλλά και μελλοντικής - πλοήγησής σου στην ιστοσελίδα, βελτιώνοντας την εμπειρία σου.',
  delete_cookies: 'Πώς μπορώ να διαγράψω τα cookies;',
  delete_cookies_description_1:
    'Μπορείς να διαγράψεις τα cookies και να απενεργοποιήσεις τη χρήση τους. Επίλεξε τον browser που χρησιμοποιείς και ακολούθησε τις οδηγίες:',
  delete_cookies_description_2: 'Εάν χρησιμοποιείς κάποιον άλλον browser, συμβουλεύσου τις πληροφορίες του παρόχου.',
  tracker_: 'Ιχνηλάτης',
  duration_: 'Διάρκεια λειτουργίας',
  data_controller: 'Υπεύθυνος Επεξεργασίας',
  recipients_: 'Αποδέκτες',
  participations_: 'Συμμετοχές',
  delivery_order_online: 'Παράγγειλε Online',
  view_not_available_coupons: 'Δες τα μη διαθέσιμα',
  coupon_code_invalid_chars_message: 'Ο κωδικός που έβαλες περιέχει μη υποστηριζόμενους χαρακτήρες: INVALID_CHARS.',
  comment_has_invalid_chars_message: 'Το μήνυμα περιέχει μη υποστηριζόμενους χαρακτήρες: INVALID_CHARS.',
  always_: 'Πάντα',
  see_the_video: 'Δες το video',
  eat_and_win_with_box: 'Με το ΒΟΧ, τρως και κερδίζεις.',
  yes_we_are_not_exaggerating: 'Ναι. Δεν είμαστε υπερβολικοί.',
  because_with_every_order_points_coming:
    'Γιατί μαζί με κάθε παραγγελία, έρχονται και <b>πόντοι</b>, δηλαδή <b>ευρώ για εκπτώσεις</b> όπως, όπου, όποτε ξαναπεινάσεις.',
  delivery_suspended_due_to_extraordinary_circumstances: 'Αδυναμία διανομής λόγω έκτακτων συνθηκών',
  not_accepting_orders_currently: 'Δεν δέχεται παραγγελίες αυτή τη στιγμή',
  outside_working_hours: 'Εκτός ωραρίου',
  other_stores: 'Άλλα καταστήματα (_SHOP_NAME)',
  found_one_shop: 'Βρήκαμε 1 κατάστημα',
  see_the_stores_by_variety: 'Δες τα καταστήματα ανά ποικιλία',
  delivery_currently_not_possible: 'Αυτή τη στιγμή δεν είναι δυνατή η διανομή από αυτό το κατάστημα',
  order_from_store_to_rate: 'Παράγγειλε από το κατάστημα ώστε να μπορείς να δίνεις τις δικές σου αξιολογήσεις!',
  applicable_laws_compliance:
    'Η επιχείρηση δεσμεύεται να προσφέρει μόνο προϊόντα ή υπηρεσίες που συμμορφώνονται με τους κανόνες του δικαίου της Ε.Ε',
  cookies_and_similar_technologies: 'Cookies και παρόμοιες τεχνολογίες',
  settings_for_cookies_and_similar_technologies: 'Ρυθμίσεις για cookies και παρόμοιες τεχνολογίες',
  accept_all: 'Αποδοχή όλων',
  only_required: 'Αποδοχή μόνο απαραίτητων',
  only_selected: 'Μόνο τα επιλεγμένα',
  on_: 'Ενεργά',
  off_: 'Ανενεργά',
  always_on: 'Πάντα ενεργά',
  read_more: 'Διαβάστε περισσότερα',
  privacy_policy_inform: 'Ενημέρωση Προστασίας Δεδομένων',
  partner_list: 'Λίστα Συνεργατών (_PARTNERS_NUMBER)',
  partner_list_title: 'Λίστα συνεργατών-αποδεκτών και ιχνηλατών που χρησιμοποιούνται στην Ιστοσελίδα',
  redeemed_: 'Εξαργυρώθηκε',
  day_shorthand: 'ημ',
  hour_shorthand: 'ω',
  your_coupon_has_expired: 'Το κουπόνι σου έληξε',
  in_shop: 'Σε SHOP_NAME',
  the_review_will_be_displayed_publicly:
    'Η κριτική θα εμφανιστεί δημοσίως με τα στοιχεία χρήστη (όνομα και αρχικό γράμμα επιθέτου).',
  delivery_details: 'Στοιχεία διανομής',
  documents_: 'Παραστατικά',
  phone_: 'Τηλέφωνο',
  gaty_number: 'Γενική Άδεια Ταχυδρομικών Υπηρεσιών Ε.Ε.Τ.Τ με ΑΜ: 95-001/2024',
  full_name: 'Ονοματεπώνυμο',
  gemh_number: 'Αριθμός ΓΕΜΗ',
  brand_name: 'Επωνυμία',
  creation_date: 'Ημερομηνία δημιουργίας',
  print_: 'Εκτύπωση',
  select_document: 'Διάλεξε παραστατικό',
  order_again: 'Παράγγειλε ξανά',
  for_your_order: 'Για την παραγγελία σου!',
  for_your_order_on: 'Για την παραγγελία σου στις:',
  shipped_at_your_door_at: 'Έφθασε στην πόρτα σου στις:',
  the_order: 'Παραγγελία',
  administrator_: 'Διαχειριστής',
  recipient_: 'Παραλήπτης',
  store_: 'Κατάστημα',
  document_type_uppercase: 'ΕΙΔΟΣ ΠΑΡΑΣΤΑΤΙΚΟΥ',
  delivery_details_uppercase: 'ΣΤΟΙΧΕΙΑ ΔΙΑΝΟΜΗΣ',
  the_order_uppercase: 'ΠΑΡΑΓΓΕΛΙΑ',
  code_uppercase: 'ΚΩΔΙΚΟΣ',
  creation_date_uppercase: 'ΗΜΕΡΟΜΗΝΙΑ ΔΗΜΙΟΥΡΓΙΑΣ',
  recipient_uppercase: 'ΠΑΡΑΛΗΠΤΗΣ',
  full_name_uppercase: 'ΟΝΟΜΑΤΕΠΩΝΥΜΟ',
  address_uppercase: 'ΔΙΕΥΘΥΝΣΗ',
  phone_uppercase: 'ΤΗΛΕΦΩΝΟ',
  store_uppercase: 'ΚΑΤΑΣΤΗΜΑ',
  brand_name_uppercase: 'ΕΠΩΝΥΜΙΑ',
  gemh_number_uppercase: 'ΑΡΙΘΜΟΣ ΓΕΜΗ',
  organism_title_uppercase: 'ΟΡΓΑΝΙΣΜΟΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε. (ΟΤΕ Α.Ε.)',
  gaty_number_uppercase: 'ΓΕΝΙΚΗ ΑΔΕΙΑ ΤΑΧΥΔΡΟΜΙΚΩΝ ΥΠΗΡΕΣΙΩΝ Ε.Ε.Τ.Τ με ΑΜ: 95-001/2024',
  updated_history: 'Aνανεωμένο ιστορικό',
  by_clicking_on_an_order_you_can_see_all_its_details:
    'Πατώντας σε μία παραγγελία, μπορείς να δεις όλες τις λεπτομέρειες της.',
  delivery_suspended_temporarily: 'Προσωρινή αδυναμία διανομής',
  in_progress_it_will_be_at_your_door_at_about: 'Σε εξέλιξη, θα είναι στην πόρτα σου περίπου στις:',
  scheduled_for: 'Προγραμματισμένη για:',
  gaty_number_compact: 'ΓΑΤΥ: 95-001/2024',
  terms_and_conditions_for_the_provision_of_postal_services: 'Όροι για Ταχυδρομικές Υπηρεσίες',
  charter_of_obligations_towards_consumers: 'Χάρτης Υποχρεώσεων Καταναλωτή',
  policy_against_misuse: 'Πολιτική Αθέμιτης Χρήσης',
  complaint_handling_policy: 'Πολιτική Διαχείρισης Παραπόνων',
  box_terms_of_use: 'Όροι χρήσης ΒΟΧ',
  terms_and_policies: 'Όροι και Πολιτικές',
  transparency_report: 'Έκθεση διαφάνειας',
  transparency_report_uppercase: 'ΕΚΘΕΣΗ ΔΙΑΦΑΝΕΙΑΣ',
  you_can_view_the_transparency_report: 'Μπορείτε να δείτε την Έκθεση Διαφάνειας 2024',
  read_in_detail_the_personal_data_protection_notice:
    'Διαβάστε αναλυτικά την ενημέρωση προστασίας προσωπικών δεδομένων',
  data_privacy_notice_title:
    'ΕΝΗΜΕΡΩΣΗ ΑΝΑΦΟΡΙΚΑ ΜΕ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΩΝ ΠΡΟΣΩΠΙΚΩΝ ΣΑΣ ΔΕΔΟΜΕΝΩΝ ΜΕΣΩ ΤΗΣ ΥΠΗΡΕΣΙΑΣ BOX (Data Privacy Notice)',
  weighted_fee: 'Χρέωση για ζυγιζόμενα',
  not_available: 'Μη διαθέσιμο',
  accessibility_statement: 'Δήλωση Προσβασιμότητας',
  accessibility_statement_uppercase: 'ΔΗΛΩΣΗ ΠΡΟΣΒΑΣΙΜΟΤΗΤΑΣ',
  you_can_view_the_accessibility_statement: 'Μπορείτε να δείτε την Δήλωση Προσβασιμότητας'
};
